import {
  Box,
  TextField,
  FormControl,
  InputAdornment,
  InputLabel,
  Input,
  Button,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  Alert,
  Card,
  Chip,
  chipClasses,
  Divider,
  Paper,
  InputBase,
  Stack,
  Modal as MuiModal,
  Tooltip,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { styled } from "@mui/material/styles";
import {
  AccountCircleOutlined,
  Visibility,
  VisibilityOff,
  LockOutlined,
  Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { useSelector, useDispatch } from "react-redux";
import { cloneDeep, set } from "lodash";
import { Tabs } from "../../components/tabs";
import { Grid } from "../../components/table";
import { CONFIG } from "../../../config";
import axios from "axios";
import { ToolBar } from "../../components/toolbar";
import { Modal } from "../../components/modal";
import { FormA, SelectA } from "../../components/form";
import moment from "moment";
import { getFormState } from "../../../helpers/form";
import dayjs from "dayjs";
import Sidebar from "./sidebar";
import CallIcon from "@mui/icons-material/Call";
import { receiveUser } from "../../../state/user/actions";
import DangerousIcon from "@mui/icons-material/Dangerous";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { Notice } from "../../components/notice";
import notificationSound from "../../../assets/sounds/notification.mp3";
import SendIcon from "@mui/icons-material/Send";
import EcdReportForm from "./ecd-report-form";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

import { toast } from "react-hot-toast";

// Full screen loader
import FullScreenLoader from "./components/fullscreen-loader";

const completedStatus = [
  "Language Barrier",
  "Call done", //TODO:: common file
  "Invalid",
  "Not in the portal",
  "Miscarriage",
  "Deceased Child",
  "Deceased Mother",
  "Deceased (Mother and Child)",
  "Duplicate Mother Id",
  "Child above 2 years",
];

const durationPulgin = require("dayjs/plugin/duration");
dayjs.extend(durationPulgin);

const { Manager } = require("socket.io-client");

const API_HOST = CONFIG.modules["accounts"].host;
const API_HOST_CRM = CONFIG.modules["crm"].host;

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

function Iframe2({ customer, agentid, phoneNumber, pin }) {
  const iframe = `<iframe id="ozoneClick" src="https://in-ccaas.ozonetel.com/toolbar_widget/index.html?action=formLogin&customer=${customer}&agentid=${agentid}&phoneNumber=${phoneNumber}&pin=${pin}&width=600#dashboard-agent" width="100%" height="100%"></iframe>`;

  return (
    <div
      style={{ height: "80vh" }}
      dangerouslySetInnerHTML={{ __html: iframe ? iframe : "" }}
    />
  );
}

function Iframe({ customer, agentid, phoneNumber, pin }) {
  const iframe = `<iframe 
   allow="geolocation *; microphone *; autoplay *; notifications *; camera *; display-capture *; fullscreen *; web-share *; payment *; usb *; serial *; hid *; midi *; magnetometer *; gyroscope *; accelerometer *; ambient-light-sensor *; encrypted-media *; oversized-images *; speaker-selection *; sync-xhr *; unoptimized-images *; unsized-media *; vr *; xr-spatial-tracking *; clipboard-read *; clipboard-write *; background-fetch *; idle-detection *; payment *; picture-in-picture *; screen-wake-lock *; interest-cohort *; Browse-topics *; attribution-reporting *; shared-storage *; private-aggregation *; storage-access *; popups *; popups-to-escape-sandbox *; top-navigation-by-user-activation *; top-navigation-to-custom-protocols *"
   sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-forms allow-modals allow-top-navigation allow-top-navigation-by-user-activation"
  id="ozoneClick" src="https://agent.cloudagent.ozonetel.com/login" width="100%" height="100%"></iframe>`;

  return (
    <div
      style={{ height: "80vh" }}
      dangerouslySetInnerHTML={{ __html: iframe ? iframe : "" }}
    />
  );
}

// const CustomerOrig = "nhm_meghalaya";
// const Customer = "ambit_poc";
const Customer = "nhm_meghalaya";
// const Customer = "ambit_poc"; // Ozonetel test account

// const apiKeyOrig = "KK6530499e65627bd1f85eb8d669b52cf9";
// const apiKey = "KK0595b75312fad74dfee44835f3af22eb";
const apiKey = "KK6530499e65627bd1f85eb8d669b52cf9";
// const apiKey = "KK0595b75312fad74dfee44835f3af22eb" // Ozonetel test account
const loginObj = {
  action: "Login",
  apiKey: "KK6530499e65627bd1f85eb8d669b52cf9",
  userName: "nhm_meghalaya",
  phoneNumber: "9127067064",
  agentId: "Pooja_Dasgupta",
  pin: 237,
};

// const iframe =
//   '<iframe id="ozoneClick" src="https://in-ccaas.ozonetel.com/toolbar_widget/index.html#dashboard-agent" width="100%" height="100%"></iframe>';

// function Iframe(props) {
//   return (
//     <div
//       style={{ height: "80vh" }}
//       dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }}
//     />
//   );
// }

const noti = new Audio(notificationSound);

const fields = [
  {
    type: "text",
    label: "MotherID",
    required: true,
    name: "motherID",
  },
  {
    type: "text",
    label: "Name",
    required: true,
    name: "name",
  },
  {
    type: "text",
    label: "Contact",
    required: true,
    name: "contact",
  },

  {
    type: "select",
    label: "Districts",
    option: { key: "Districts", value: "_id", label: "name" },
    required: true,
    name: "districtId",
  },
];

export const CallerView = (props) => {
  let socket;
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
    map,
    Campaigns,
  } = useSelector((state) => state.user || {});
  const userStore = useSelector((state) => state.user || {});
  const dispatch = useDispatch();

  const [campaign, setCampaign] = useState(null);

  // TODO: This is being done like this because there is only one compaign. In future when multiple campaigns are required remove this
  useEffect(() => {
    if (Campaigns) {
      setCampaign(Campaigns[0]._id);
    }
  }, [Campaigns]);

  const [active, setActive] = useState("Employees");
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openNewCase, setOpenNewCase] = useState(false);
  const [action, setAction] = useState("new");
  const [saved, setSaved] = useState(null);
  const [index, setIndex] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [ozone, setOzone] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [notification, setNotification] = useState(null);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [transfering, setTransfering] = useState(false);
  const [ecd, setEcd] = useState({});
  const [oldEcd, setOldEcd] = useState([]);
  const [formData, setFormData] = useState({});
  const [formData2, setFormData2] = useState({});
  const [savedN, setSavedN] = useState(null);
  const [searchK, setSearchK] = useState("");
  const [searched, setSearched] = useState(null);
  const [inboundAction, setInboundAction] = useState(null);

  const [openLogin, setOpenLogin] = useState(false);
  const [loginObj, setLoginObj] = useState(null);
  const [savingLogin, setSavingLogin] = useState(false);
  const [loginData, setLoginData] = useState({});
  const [saveMessage, setSaveMessage] = useState(null);
  const [changePhone, setChangePhone] = useState(false);
  const [newPhone, setNewPhone] = useState(null);

  // state for handling refreshing iframe
  const [showOzonetelIframe, setShowOzonetelIframe] = useState(true);

  const [numberChangeExpanded, setNumberChangeExpanded] = useState(false);

  const [expanded, setExpanded] = useState("panel1");
  const [filter, setFilter] = useState({});

  // State related to showing errors in ECD form
  const [ECDFormErrors, setECDFormErrors] = useState({});

  // State related to showing languages in transfer scree
  const [language, setLanguage] = useState("");
  const [languageError, setLanguageError] = useState(false);
  const [savingEcd, setSavingEcd] = useState(false);

  // State for reattempt modal
  const [openReattemptModal, setOpenReattemptModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    dayjs().format("YYYY-MM-DD")
  ); // Initialize with current date

  // state for showing loading spinner when using not connected status
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);

  // state for not allowing multiple click of the call button
  const [isCallingCrm, setIsCallingCrm] = useState(false);
  const handleOpenReattemptModal = () => {
    setOpenReattemptModal(true);
  };

  const handleCloseReattemptModal = () => {
    setSelectedDate(dayjs().format("YYYY-MM-DD"));
    setOpenReattemptModal(false);
  };
  // HANDLE REATTEMPT SAME DAY
  const handleReattemptSameDay = async () => {
    // Logic for reattempting on the same day

    let today = dayjs();
    setIsUpdatingStatus(true);
    // first saving the status
    // updateStatus last paremeter is reattempt value which will be sent to the backend
    let reattemptStatus = true;

    // before we save the ecd, we gotta add the reattempt day
    let localFormData = cloneDeep(formData);
    localFormData.callDate = dayjs();

    await updateStatusAndSaveECD({
      caseRelated: {
        id: selectedData._id,
        status: formData.callStatus,
        selectedDay: today,
        reattempt: reattemptStatus,
      },
      ecdRelated: {
        localFormData: localFormData,
        forType: "reattempt",
      },
    });
    // await updateStatus(selectedData._id, formData.callStatus, today, reattemptStatus);

    // await saveEcd(localFormData, "reattempt");

    // remove the selectedData from data;
    // let newData = data.filter((e) => e._id != selectedData._id);
    // setData(newData);

    // close the modal first before removing the spinner
    // handleCloseReattemptModal();
    // setIsUpdatingStatus(false);
  };

  // HANDLE REATTEMPT ON SELECTED DATE
  const handleReattemptOnSelectedDate = async () => {
    // Logic for reattempting on the selected date

    let selectedDay = dayjs(selectedDate);

    setIsUpdatingStatus(true);

    // first saving the status
    // updateStatus last paremeter is reattempt value which will be sent to the backend
    let reattemptStatus = true;
    await updateStatus(
      selectedData._id,
      formData.callStatus,
      selectedDay,
      reattemptStatus
    );

    // before we save the ecd, we gotta add the reattempt day
    let localFormData = cloneDeep(formData);
    localFormData.callDate = dayjs(selectedDate);
    await saveEcd(localFormData, "reattempt");

    // close the modal first before disbaling the spinner
    handleCloseReattemptModal();
    setIsUpdatingStatus(false);
  };

  useEffect(() => {
    if (user) {
      console.log("-------------->", user);
      if (!user.loginObj) {
        setOpenLogin(true);
      } else {
        setLoginObj(user.loginObj);
      }
    }
  }, [user]);

  const deleteInboundCase = (id) => {
    axios
      .delete(API_HOST_CRM + "/inbound/case/" + id)
      .then((resp) => {
        if (resp.data && resp.data.success) {
          let newData = [...data];
          // const index = newData.findIndex(e=>e._id == id)
          // newData[index].status = status
          setData(newData.filter((e) => e._id != id));
          setSelectedData(null);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (oldEcd.length > 0) {
      const lastEcd = oldEcd[oldEcd.length - 1];
      console.log(oldEcd);
      console.log("old", lastEcd);
      delete lastEcd._id;
      setEcd({
        ...lastEcd,
        callStatus: "",
        connectivityStatus: selectedData?.inbound ? "Connected" : "",
        dataType: selectedData?.inbound ? "Inbound" : "Follow-ups",
        callerType: "",
        advice: "",

        week: lastEcd.week || 1,
        age: lastEcd.age || "",
        pregnancyMonth: lastEcd.pregnancyMonth || "One",
      });
    } else {
      setEcd({
        dataType: selectedData?.inbound ? "Inbound" : "New Data",
        week: 1,
        pregnancyMonth: "One",
        trimester: "One",
        connectivityStatus: selectedData?.inbound ? "Connected" : "",
      });
    }
  }, [oldEcd]);

  useEffect(() => {
    console.log(selectedData);
    setECDFormErrors({});
  }, [selectedData]);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const onChange = (data) => {
    console.log("Is this function even running", data);

    // FORM ERROR:REMOVING the errors
    // if no data was changed then just return as errors will remain to show
    // if (!data) return;

    // prev ecd errors
    let prev = ECDFormErrors;

    // checking connectivityStatus
    // its a select and a string
    // by default its an empty string ''
    if (data.connectivityStatus && data.connectivityStatus.length !== 0) {
      // let prev = ECDFormErrors;
      delete prev.connectivityStatus;
      // setECDFormErrors((prevErrors) => ({ ...prevErrors, ...prev }));
    }

    // callStatus is also select
    if (data.callStatus && data.callStatus.length !== 0) {
      // let prev = ECDFormErrors;
      delete prev.callStatus;
      // setECDFormErrors({ ...prev });
    }

    // the rest of the code is also select
    if (data.cluster && data.cluster.length !== 0) {
      delete prev.cluster;
      // setECDFormErrors({ ...prev });
    }

    if (data.dataType && data.dataType.length !== 0) {
      delete prev.dataType;
      // setECDFormErrors({ ...prev });
    }

    if (data.callerType && data.callerType.length !== 0) {
      delete prev.callerType;
      // setECDFormErrors({ ...prev });
    }

    if (data.age || data.age !== 0) {
      delete prev.age;
      // setECDFormErrors({ ...prev });
    }

    // checking if pregnancyStatus is not empty
    if (data.pregnancyStatus && data.pregnancyStatus.length !== 0) {
      delete prev.pregnancyStatus;
      // setECDFormErrors({ ...prev });

      // pregnancyStatus
      // if pregnancyStatus is currently expecting
      if (data.pregnancyStatus === "Currently Expecting") {
        if (data.month && data.month.length !== 0) {
          delete prev.pregnancyStatus_month;
          // setECDFormErrors({ ...prev });
        }

        // if forrm data has data.week when pregnancy status is 'currently expecting'
        if (data.week) {
          delete prev.pregnancyStatus_week;
          // setECDFormErrors({ ...prev });
        }

        // if forrm data has data.trimester when pregnancy status is 'currently expecting'
        if (data.trimester && data.trimester.length !== 0) {
          delete prev.pregnancyStatus_trimester;
          // setECDFormErrors({ ...prev });
        }
        // if forrm data has data.highRisk when pregnancy status is 'currently expecting'
        if (data.highRisk && data.highRisk.length !== 0) {
          delete prev.pregnancyStatus_highRisk;
          // setECDFormErrors({ ...prev });
        }
      }

      if (data.pregnancyStatus === "Delivered") {
        // if forrm data has data.childDeliveryPlace when pregnancy status is 'Delivered'
        if (data.childDeliveryPlace && data.childDeliveryPlace.length !== 0) {
          if (data.childDeliveryPlace !== "Delivered from Home") {
            delete prev.pregnancyStatus_homeDeliverReason;
          }
          delete prev.pregnancyStatus_childDeliveryPlace;
          // setECDFormErrors({
          //   ...prev,
          // });
        }

        // if forrm data has data.homeDeliverReason when pregnancy status is 'Delivered'
        if (data.homeDeliverReason && data.homeDeliverReason.length !== 0) {
          delete prev.pregnancyStatus_homeDeliverReason;
          // setECDFormErrors({ ...prev });
        }

        // if forrm data has data.lessThen1Year when pregnancy status is 'Delivered'
        if (data.lessThen1Year && data.lessThen1Year.length !== 0) {
          delete prev.pregnancyStatus_lessThen1Year;
          // setECDFormErrors({ ...prev });
        }

        // if forrm data has data.between1And2 when pregnancy status is 'Delivered'
        if (data.between1And2 && data.between1And2.length !== 0) {
          delete prev.pregnancyStatus_between1And2;
          // setECDFormErrors({ ...prev });
        }

        // if forrm data has data.childImmunization when pregnancy status is 'Delivered'
        if (data.childImmunization && data.childImmunization.length !== 0) {
          if (data.childImmunization !== "No") {
            delete prev.pregnancyStatus_nonImmunizedReason;
          }
          delete prev.pregnancyStatus_childImmunization;
          // setECDFormErrors({ ...prev });
        }

        // if forrm data has data.nonImmunizedReason when pregnancy status is 'Delivered'
        // given this error will only happen when childImmunization is set to 'No'
        if (data.nonImmunizedReason && data.nonImmunizedReason.length === 0) {
          delete prev.pregnancyStatus_nonImmunizedReason;
          // setECDFormErrors({ ...prev });
        }
      }
    }

    if (data.ICDSSchemeStatus && data.ICDSSchemeStatus.length !== 0) {
      delete prev.ICDSSchemeStatus;
      // setECDFormErrors({ ...prev });
    }

    if (data.scheduledDate && data.scheduledDate.length !== 0) {
      delete prev.scheduledDate;
      // setECDFormErrors({ ...prev });
    }

    // callScore
    if (data.callScore && data.callScore.length !== 0) {
      delete prev.callScore;
      // setECDFormErrors({ ...prev });
    }

    // notScoringReason
    if (data.notScoringReason && data.notScoringReason.length !== 0) {
      delete prev.notScoringReason;
      // setECDFormErrors({ ...prev });
    }

    if (selectedData?.inbound && data.inboundCallType) {
      delete prev.inboundCallType;
    }

    if (!selectedData?.inbound) {
      delete prev.inboundCallType;
    }

    setECDFormErrors({ ...prev });
    setFormData({ ...data });
  };

  // FORM ERROR:SETTING the errors
  const ecdFormErrorsLogic = (data) => {
    // this sets the errors when the fields are not set,
    // there is no logic here that modifies errors based on value
    console.log("Inside the ecd form logic need to know the data", data);
    setECDFormErrors((prev) => ({ ...prev }));

    let errorObject = {};
    // checking

    if (!data.connectivityStatus) {
      errorObject.connectivityStatus =
        "'connectivity status' field is required.";
      setECDFormErrors((prev) => ({
        ...prev,
        connectivityStatus: "'connectivity status' field is required.",
      }));
      return errorObject;
    }

    // all of them are strings so check length
    if (data.connectivityStatus.length === 0) {
      setECDFormErrors((prev) => ({
        ...prev,
        connectivityStatus: "'connectivity status' field is required.",
      }));
      errorObject.connectivityStatus =
        "'connectivity status' field is required.";
      return errorObject;
    }

    if (!data.callStatus || data.callStatus.length === 0) {
      setECDFormErrors((prev) => ({
        ...prev,
        callStatus: "'call status' field is required",
      }));
      errorObject.callStatus = "'call status' field is required";
    }

    if (selectedData?.inbound) {
      if (!data.inboundCallType || data.inboundCallType.length === 0) {
        setECDFormErrors((prev) => ({
          ...prev,
          inboundCallType: "'inbound call type' field is required",
        }));
        errorObject.inboundCallType =
          "'inbound call type' field is required";
      }
    }

    if (data.callStatus) {
      if (data.callStatus === "Language Barrier") {
        return errorObject;
      }
    }

    if (data.callStatus === "Schedule Later" && !data.scheduledDate) {
      setECDFormErrors((prev) => ({
        ...prev,
        scheduledDate: "'scheduled date' field is required",
      }));
      errorObject.scheduledDate = "'scheduled date' field is required";
      return errorObject;
    }

    // Specific mandatory fields for when callStatus is 'Call done'
    if (data.callStatus === "Call done") {
      // Caller type
      if (!data.callerType || data.callerType.length === 0) {
        setECDFormErrors((prev) => ({
          ...prev,
          callerType: "'caller type' field is required",
        }));
        errorObject.callerType = "'caller type' field is required";
      }

      // Pregnancy status
      if (!data.pregnancyStatus || data.pregnancyStatus.length === 0) {
        setECDFormErrors((prev) => ({
          ...prev,
          pregnancyStatus: "'pregnancy status' field is required",
        }));
        errorObject.pregnancyStatus = "'pregnancy status' field is required";
      }

      // ICDSSchemeStatus
      if (!data.ICDSSchemeStatus || data.ICDSSchemeStatus.length === 0) {
        setECDFormErrors((prev) => ({
          ...prev,
          ICDSSchemeStatus: "'ICDSS schema status' field is required",
        }));
        errorObject.ICDSSchemeStatus =
          "'ICDSS schema status' field is required";
      }

      // Call Score
      const isCallScoreValid =
        data.callScore &&
        data.callScore !== "Nil" &&
        data.callScore !== undefined;
      const isNotScoringReasonValid =
        data.notScoringReason &&
        data.notScoringReason?.length !== 0 &&
        data.notScoringReason !== "Nil" &&
        data.notScoringReason !== undefined;

      console.log("What is data right now", data);

      if (isCallScoreValid && isNotScoringReasonValid) {
        // Scenario: Both are filled. You might want to error here depending on business logic.
        // For XOR, this would be an error.
        setECDFormErrors((prev) => ({
          ...prev,
          callScore:
            "Please fill only one of 'Call Score' or 'Not Scoring Reason'",
          notScoringReason:
            "Please fill only one of 'Call Score' or 'Not Scoring Reason'",
        }));
        errorObject.callScore =
          "Please fill only one of 'Call Score' or 'Not Scoring Reason'";
        errorObject.notScoringReason =
          "Please fill only one of 'Call Score' or 'Not Scoring Reason'";
      } else if (!isCallScoreValid && !isNotScoringReasonValid) {
        // Scenario: Neither is filled. This is always an error for "one of them mandatory".
        setECDFormErrors((prev) => ({
          ...prev,
          callScore: "Either 'Call Score' or 'Not Scoring Reason' is required",
          notScoringReason:
            "Either 'Call Score' or 'Not Scoring Reason' is required",
        }));
        errorObject.callScore =
          "Either 'Call Score' or 'Not Scoring Reason' is required";
        errorObject.notScoringReason =
          "Either 'Call Score' or 'Not Scoring Reason' is required";
      } else {
        // Scenario: Exactly one is filled. This is the valid case.
        // Clear any previous errors for these fields if they exist
        setECDFormErrors((prev) => {
          const newState = { ...prev };
          delete newState.callScore;
          delete newState.notScoringReason;
          return newState;
        });
        // Also remove from errorObject if it was previously set
        delete errorObject.callScore;
        delete errorObject.notScoringReason;
      }
    }

    // if (!data.cluster || data.cluster.length === 0) {
    //   setECDFormErrors((prev) => ({
    //     ...prev,
    //     cluster: "'cluster' field is required",
    //   }));
    //   errorObject.cluster = "'cluster' field is required";
    // }

    // if (!data.dataType || data.dataType.length === 0) {
    //   setECDFormErrors((prev) => ({
    //     ...prev,
    //     dataType: "'data type' field is required",
    //   }));
    //   errorObject.dataType = "'data type' field is required";
    // }

    // if (!data.callerType || data.callerType.length === 0) {
    //   setECDFormErrors((prev) => ({
    //     ...prev,
    //     callerType: "'caller type' field is required",
    //   }));
    //   errorObject.callerType = "'caller type' field is required";
    // }

    // if (!data.age || data.age === 0 || data.age < 0) {
    //   setECDFormErrors((prev) => ({
    //     ...prev,
    //     age: "'age' field should be valid",
    //   }));
    //   errorObject.age = "'age' field should be valid";
    // }

    // if (!data.pregnancyStatus || data.pregnancyStatus.length === 0) {
    //   setECDFormErrors((prev) => ({
    //     ...prev,
    //     pregnancyStatus: "'pregnancy status' field is required",
    //   }));
    //   errorObject.pregnancyStatus = "'pregnancy status' field is required";
    // }

    // if (!data.ICDSSchemeStatus || data.ICDSSchemeStatus.length === 0) {
    //   setECDFormErrors((prev) => ({
    //     ...prev,
    //     ICDSSchemeStatus: "'ICDSS schema status' field is required",
    //   }));
    //   errorObject.ICDSSchemeStatus = "'ICDSS schema status' field is required";
    // }

    // pregnancyStatuslogic
    // if (data.pregnancyStatus === "Currently Expecting") {
    //   if (!data.pregnancyMonth || data.pregnancyMonth.length === 0) {
    //     setECDFormErrors((prev) => ({
    //       ...prev,
    //       pregnancyStatus_month: "'Pregnancy month' field is required.",
    //     }));
    //     errorObject.pregnancyStatus_month =
    //       "'Pregnancy month' field is required.";
    //   }

    //   if (!data.week || data.week.length === 0) {
    //     setECDFormErrors((prev) => ({
    //       ...prev,
    //       pregnancyStatus_week: "'Pregnancy week' field is required.",
    //     }));
    //     errorObject.pregnancyStatus_week =
    //       "'Pregnancy week' field is required.";
    //   }

    //   if (!data.trimester || data.trimester.length === 0) {
    //     setECDFormErrors((prev) => ({
    //       ...prev,
    //       pregnancyStatus_trimester: "'Trimester' field is required.",
    //     }));
    //     errorObject.pregnancyStatus_trimester =
    //       "'Trimester' field is required.";
    //   }

    //   if (!data.highRisk || data.highRisk.length === 0) {
    //     setECDFormErrors((prev) => ({
    //       ...prev,
    //       pregnancyStatus_highRisk: "'high risk' field is required.",
    //     }));
    //     errorObject.pregnancyStatus_highRisk = "'high risk' field is required.";
    //   }
    // }

    // if (data.pregnancyStatus === "Delivered") {
    //   if (!data.childDeliveryPlace || data.childDeliveryPlace.length === 0) {
    //     setECDFormErrors((prev) => ({
    //       ...prev,
    //       pregnancyStatus_childDeliveryPlace:
    //         "'child delivery place' field is required.",
    //     }));
    //     errorObject.pregnancyStatus_childDeliveryPlace =
    //       "'child delivery place' field is required.";
    //   }

    //   // logic for if childDeliveryPlace is "Deliveries at Home"
    //   // then check if reason is given or not
    //   if (data.childDeliveryPlace) {
    //     // if valid child delivery place check Deliveries at home
    //     if (data.childDeliveryPlace === "Deliveries at home") {
    //       if (!data.homeDeliverReason || data.homeDeliverReason.length === 0) {
    //         setECDFormErrors((prev) => ({
    //           ...prev,
    //           pregnancyStatus_homeDeliverReason:
    //             "'home deliver reason' field is required.",
    //         }));
    //         errorObject.pregnancyStatus_homeDeliverReason =
    //           "'home deliver reason' field is required.";
    //       }
    //     }
    //   }

    //   if (!data.lessThen1Year || data.lessThen1Year.length === 0) {
    //     setECDFormErrors((prev) => ({
    //       ...prev,
    //       pregnancyStatus_lessThen1Year:
    //         "'less then 1 year' field is required.",
    //     }));
    //     errorObject.pregnancyStatus_lessThen1Year =
    //       "'less then 1 year' field is required.";
    //   }

    //   if (!data.between1And2 || data.between1And2.length === 0) {
    //     setECDFormErrors((prev) => ({
    //       ...prev,
    //       pregnancyStatus_between1And2: "'between 1 and 2' field is required.",
    //     }));
    //     errorObject.pregnancyStatus_between1And2 =
    //       "'between 1 and 2' field is required.";
    //   }

    //   if (!data.childImmunization || data.childImmunization.length === 0) {
    //     setECDFormErrors((prev) => ({
    //       ...prev,
    //       pregnancyStatus_childImmunization:
    //         "'child immunization' field is required.",
    //     }));
    //     errorObject.pregnancyStatus_childImmunization =
    //       "'child immunization' field is required.";
    //   }

    //   if (data.childImmunization) {
    //     if (data.childImmunization === "No") {
    //       if (
    //         !data.nonImmunizedReason ||
    //         data.nonImmunizedReason.length === 0
    //       ) {
    //         setECDFormErrors((prev) => ({
    //           ...prev,
    //           pregnancyStatus_nonImmunizedReason:
    //             "'non immunized reason' field is required.",
    //         }));
    //         errorObject.pregnancyStatus_nonImmunizedReason =
    //           "'non immunized reason' field is required.";
    //       }
    //     }
    //   }
    // }

    // if (
    //   data.callStatus &&
    //   data.connectivityStatus &&
    //   data.callStatus.length !== 0 &&
    //   data.connectivityStatus.length !== 0
    // ) {
    //   return {};
    // }

    return errorObject;
    console.log("errors", ECDFormErrors);
    if (Object.keys(EcdReportForm).length > 0) {
      return;
    }
  };

  const getECD = (id) => {
    setExpanded(false);
    setEcd({
      connectivityStatus: selectedData?.inbound ? "Connected" : "",
      dataType: selectedData?.inbound ? "Inbound" : "New Data",
    });
    axios
      .get(API_HOST_CRM + "/ecd?id=" + id)
      .then((resp) => {
        if (resp.data && resp.data.success && resp.data.ecd) {
          setEcd(resp.data.ecd);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getPReviousECD = () => {
    axios
      .get(
        API_HOST_CRM +
        `/ecd/previous?motherID=${selectedData.motherID}&caseId=${selectedData._id}`
      )
      .then((resp) => {
        if (resp.data && resp.data.success) {
          // console.log("oldEcd", resp.ecd );
          setOldEcd(resp.data.ecd);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const search = (ecd) => {
    axios
      .get(API_HOST_CRM + `/search-case-mother?id=${searchK}&ecd=${ecd}`)
      .then((resp) => {
        if (resp.data && resp.data.success) {
          if (resp.data.data) {
            setSearched(resp.data.data);
          } else {
            setSearched("not found");
          }

          // console.log("oldEcd", resp.ecd );
          // setOldEcd(resp.data.ecd)
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  /**
   * 
   * ! NOTE: This function might not receive the second and third parameter so always check
   * @param {*} id 
   * @param {*} motherID 
   * @param {*} formD 
   */
  const saveMotherDetails = (id, motherID, formD) => {
    //

    // Need to find the district
    let districtName = map.Districts[formData2.districtId]?.name;
    let districtId = formData2.districtId;

    if (formD) {
      districtName = map.Districts[formD.districtId]?.name;
      districtId = formD.districtId;
    }


    // console.log(`[CallerView.saveMotherDetails] district information: `, districtName, districtId);

    axios
      .post(API_HOST_CRM + `/save-mother`, {
        id: id,
        data: {
          ...formData2,
          districtName: districtName,
          ...(inboundAction == "new" ? { motherID } : {}),
          ...(formD || {}),
          districtId: districtId,
        },
      })
      .then((resp) => {
        console.log(resp, "response from save mother details");
        if (resp.data && resp.data.success) {
          // react does batch state updates, so newData might not have the latest updates from the createNewInboundCase
          let newData = [...data];

          let index = newData.findIndex((e) => e._id == id);

          // if not found
          if (index === -1) {
            newData.push(resp.data.case);
          }

          index = newData.findIndex((e) => e._id == id);

          newData[index] = { ...resp.data.case };
          setData(newData);
          setSelectedData(newData[index]);
          setOpen(false);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        // finally block
        setSearched(null);
      });
  };

  /**
   *This is an async alternative to saveMotherDetails
   *
   * Only being used right now in the createNewInboundCaseTest
   * Saving it for when we need to use async await instead of promises again.
   */
  const saveMotherDetailsAsync = async (id, motherID, formD) => {
    try {
      const saveMotherDetailsResponse = await axios.post(
        API_HOST_CRM + `/save-mother`,
        {
          id: id,
          data: {
            ...formData2,
            districtName: map.Districts[formData2.districtId]?.name,
            ...(inboundAction == "new" ? { motherID } : {}),
            ...(formD || {}),
          },
        }
      );

      if (
        saveMotherDetailsResponse.data &&
        saveMotherDetailsResponse.data.success
      ) {
        // react does batch state updates so this newData might not have the latest data
        let newData = [...data];

        let index = newData.findIndex((e) => e._id == id);

        if (index === -1) {
          newData.push(saveMotherDetailsResponse.data.case);
        }

        index = newData.findIndex((e) => e._id == id);

        console.log(
          "found the case when saving the details",
          index,
          newData[index]
        );
        newData[index] = { ...saveMotherDetailsResponse.data.case };
        setData(newData);
        setSelectedData(newData[index]);
        setOpen(false);
      }
    } catch (e) {
      console.log("Error occurred during saving mother details:", e);
    }
  };

  // saveECD function
  const saveEcd = async (d, forType) => {
    if (savingEcd) {
      return;
    }
    const data = { ...d };
    if (data.age) {
      data.age = parseInt(data.age);
    }
    if (data.week) {
      data.week = parseInt(data.week);
    }

    let formData = {
      ...data,
      caseId: selectedData._id,
      agent: selectedData.allocatedToUser,
      callDate: selectedData.callDate,
      bName: selectedData.name,
      motherID: selectedData.motherID,
      mNumber: selectedData.contact,
      district: selectedData.districtName,
      callType: data.inbound ? "Inbound" : "Outbound",
      reattempt: forType === "reattempt" ? true : false,
    };

    if (forType) {
      if (forType === "reattempt") {
        formData.callDate = d.callDate;
      }
    }

    setSavingEcd(true);
    await axios
      .post(API_HOST_CRM + "/ecd", {
        // ecd method is sending a body data called data.
        // update status is not sending something like this so data is unique for ecd
        data: {
          ...formData,
        },
        ...(ecd ? { ecd_id: ecd._id } : {}), //see
      })
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setEcd(resp.data.ecd);
          setSavedN("ECD status & data saved successfully.");
          setECDFormErrors({});
        }
        setSavingEcd(false);
      })
      .catch((e) => {
        toast.error("Something went wrong.", {
          position: "top-center",
        });
        handleCloseReattemptModal();
        setIsUpdatingStatus(false);
        console.log(e);
        setSavingEcd(false);
      });
  };

  useEffect(() => {
    if (selectedData && selectedData._id) {
      getECD(selectedData._id);
      getPReviousECD();
    }
  }, [selectedData]);

  useEffect(() => {
    axios
      .get(API_HOST_CRM + "/my-cases?limit=200")
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setData(resp.data.cases);
          // change it to add an array of group users
          //  let enwjdbas = resp.data.cases.map(obj => {
          //     obj.push({obj,isGroup :groupMothers})
          //     return;
          // })
          // setData(resp.data.cases)
          // setData({...resp.data.cases,isGroup :groupMothers})
          console.log(resp.data.cases, "selected data");
        }
        console.log(resp, "resp");
      })
      .catch((e) => {
        console.log(e);
      });

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      socket.emit("disconnect");
      // event.returnValue = '';
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      if (socket) {
        socket.removeAllListeners();
      }
    };
  }, []);

  useEffect(() => {
    if (user) {
      const manager = new Manager(CONFIG.modules["crm"].socket, {
        reconnectionDelayMax: 10000,
        path: "/crm",
      });
      socket = manager.socket("/common", {
        query: {
          token: localStorage.getItem("authToken") || "",
        },
      });
      // console.log('mm', user._id)
      socket.on(`${user._id}-new-pending-cases`, (cases) => {
        if (cases.length > 0) {
          // console.log('mmm', user._id)
          setNotification(`${cases.length} new pending cases added.`);
          noti.play();
          setData((previous) => [...previous, ...cases]);
        }
      });

      // deallocation real time
      socket.on("case-update-deallocate", (caseIds) => {
        toast(`${caseIds.length} Cases deallocated.`);
        let newClientData = [...data];
        // newClientData = newClientData.filter((d) => !caseIds.includes(d._id));
        setData((prevState) => {
          return prevState.filter((e) => !caseIds.includes(e._id));
        });
      });

      // getting new inbound case
      socket.on(`${user._id}-case-new-inbound`, (caseData) => {
        if (caseData.case) {
          console.log("The case data: ", caseData);
          setNotification("New inbound case added.");
          noti.play();
          setData((previous) => [...previous, caseData.case]);
          setSelectedData({
            ...caseData.case,
            // isGroup: caseData.case.contact
          });
        }
      });

      /**
       * Feature Request Dated 03/12/2025
       * 
       * Description same contact cases to be updated to active
       */
      // socket.on(`${user._id}-case-update-same-contact`, (caseData) => {
      //   // caseData will contain cases array which will be ids
      //   const socketCases = caseData?.cases ?? [];

      //   if (socketCases.length > 0) {
      //     setData((prevState) => {
      //       let newState = [...prevState];
      //       socketCases.forEach((socketCase) => {
      //         const index = newState.findIndex(e => e._id === socketCase);
      //         if (index !== -1) {
      //           newState[index] = {
      //             ...newState[index],
      //             status: "Active",
      //           };
      //         }
      //       });
      //       return newState;
      //     });
      //   }

      // });
    }
  }, [user]);

  useEffect(() => {
    if (Array.isArray(data) && data[0]) {
      // setSelectedData(data[0])
    }
    //
  }, [data]);

  useEffect(() => {
    if (user && user.ozone) {
      setOzone(user.ozone);
    }
  }, [user]);

  const changeToNewPhoneNumber = () => {
    axios
      .put(API_HOST_CRM + `/ecd/change-contact-numbers`, {
        newNumber: newPhone,
        _id: selectedData._id,
      })
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setChangePhone(false);
          setSelectedData({ ...selectedData, ...resp.data.updated });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const saveLogin = () => {
    console.log(loginData);
    axios
      .put(API_HOST + `/ozonetel/${user._id}`, {
        data: loginData,
      })
      .then((resp) => {
        if (resp.data && resp.data.success) {
          console.log(resp.data);
          dispatch(receiveUser(resp.data.user));
        }
        setSaveMessage("Ozontel login details saved successfully!");
        setTimeout(() => {
          setOpenLogin(false);
          setSaveMessage(null);
        }, 1500);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const tryLogin = () => {
    const options = {
      method: "POST",
      headers: {
        accept: "application/json",
        "content-type": "application/x-www-form-urlencoded",
        authorization: "Basic UG9vamFfRGFzZ3VwdGE6MjM3",
      },
      body: new URLSearchParams({
        action: "Login",
        apiKey: "KK6530499e65627bd1f85eb8d669b52cf9",
        userName: "nhm_meghalaya",
        phoneNumber: "9127067064",
      }),
    };

    fetch(
      "https://in1-ccaas-api.ozonetel.com/CAServices/AgentAuthenticationV2/index.php",
      options
    )
      .then((response) => {
        // handleCall()
        response.json();
      })
      .then((response) => console.log(response));
  };
  useEffect(() => {
    if (ozone) {
      // tryLogin()
      // setTimeout(()=> {
      //     var iframe = document.getElementById('ozoneClick');
      //     var innerDoc = iframe.contentDocument || iframe.contentWindow.document;
      //     innerDoc.querySelector('#login-submit').click()
      // },5000)
    }
  }, [ozone]);

  const tryTransferCase = async () => {
    try {
      const result = await axios.post(API_HOST_CRM + "/transfer-case", {
        id: selectedData._id,
        by: user._id,
        language: language,
        campaign: campaign,
      });

      if (result.data.success) {
        toast.success(result.data.message);
        // console.log(resp.data)
        if (result.data && result.data.success) {
          // setNotification("Chat transferred successfully.");
          let newData = [...data];
          // const index = newData.findIndex(e=>e._id == id)
          // newData[index].status = status
          setData(newData.filter((e) => e._id != selectedData._id));
          setSelectedData(null);
        }
      }

      if (result.data && result.data.error) {
        toast.error(result.data.message, {
          position: "top-center",
        });
        toast.error("Notify team lead to transfer the case.", {
          position: "top-center",
        });
        // console.log(resp.data)
        // even if the rror is true
        /**
         *  if (result.data && result.data.error) {
          // setNotification("Chat transferred successfully.");
          let newData = [...data];
          // const index = newData.findIndex(e=>e._id == id)
          // newData[index].status = status
          setData(newData.filter((e) => e._id != selectedData._id));
          setSelectedData(null);
        }
         */
      }
    } catch (error) {
      console.log("Error during transferring", error);
      toast.error("Something went wrong.", {
        position: "top-center",
      });
    } finally {
      setTransfering(false);
    }

    // axios
    //   .post(API_HOST_CRM + "/transfer-a-case", {
    //     id: selectedData._id,
    //     by: user._id,
    //     language: language,
    //   })
    //   .then((resp) => {
    //     // console.log(resp.data)
    //     if (resp.data && resp.data.success) {
    //       setNotification("Chat transferred successfully.");
    //       let newData = [...data];
    //       // const index = newData.findIndex(e=>e._id == id)
    //       // newData[index].status = status
    //       setData(newData.filter((e) => e._id != selectedData._id));
    //       setSelectedData(null);
    //     }
    //     setTransfering(false);
    //   })
    //   .catch((e) => {
    //     setTransfering(false);
    //     console.log(e);
    //   });
  };

  const saveAndEdit = async (formD) => {
    console.log("fff", formD);

    createNewInboundCase(saveMotherDetails, formD);

    // lets try the async function
    // here the first param is a cb function, right now only checking if the cb is passed and calling the saveMotherDetailsAsync method
    // not actually calling the saveMotherDetailsmethod.
    // await createNewInboundCaseTest(saveMotherDetails, formD);
  };
  useEffect(() => {
    if (selectedData?.inbound) {
      // setEcd({
      //     ...ecd,
      //     connectivityStatus: 'Connected'
      // })
    }
  }, [selectedData]);

  const createNewCase = (ecdId, parent) => {
    axios
      .post(API_HOST_CRM + "/create-new-mother-case", {
        user,
        ecdId,
        parent,
      })
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setData([resp.data.case, ...data]);
          setSelectedData(resp.data.case);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  /**
   * Right now the cb function is the saveMotherDetails method;
   */
  const createNewInboundCase = (cb, formD) => {
    // Need to handle when we already have the case meaning we should not create the new inbound case because it
    // is already created. Also check if the motherID is same as the searched motherID, if it is the same then also we should not create a new inbound case because it is already created. We can directly call the cb function to update the details if needed.
    if (selectedData?.inbound && searched && formD?.motherID && searched !== "not found" && formD.motherID === searched.motherID && selectedData.motherID === searched.motherID) {
      // console.log("Mother ID is not the same but the data is here anyways: ", formD, searched)
      // console.log("cb is provided: ", cb)
      if (!cb) return;
      // NOTE: this callback is for when we are creatign a new inbound case
      // we are not passing any formD
      let condMotherID = "inbound-random"; // this is actually what is being saved in the database when are creating a new one
      if (formD?.motherID) {
        condMotherID = formD.motherID;
      } else {
        condMotherID = selectedData.motherID;
      }

      console.log("whats the mother id", condMotherID);
      // okk we need to do one thing, if this condMotherId is not inbound-random
      // lets pass the formData2 as teh formD

      let properFormD = formD;
      //
      if (condMotherID !== "inbound-random") {
        properFormD = formD;
      } else {
        properFormD = formD;
      }

      // cb(resp.data.case._id, condMotherID, formD);

      // because this a callback, the ui won't update aahhhhh
      // why don't we just call the saveMotherDetails, that would save the hassle
      // we need to make sure this callback runs and the ui data sidebar updates
      // console.log("[CallerView] properForm: ", properFormD, formD);
      let districtName = "";
      // Need to add strict name as well so lets search for the district name using districtId
      if (Districts && properFormD.districtId) {
        const foundDistrict = Districts.find(
          (d) => d._id === properFormD.districtId
        );

        if (foundDistrict) {
          districtName = foundDistrict.name;
          properFormD.districtName = districtName;
        }
      }

      // console.log(`[CallerView.createNewInboundCase] district information: `, properFormD.districtName, districtName);

      cb(selectedData._id, condMotherID, properFormD);

      // need to clear the formData2 as well
      // cause why not
      setFormData2({});
      return;
    }

    // console.log("NO cb method provided: ",)

    const inboundDetails = formD || formData2 || {};
    const motherID =
      typeof inboundDetails.motherID === "string"
        ? inboundDetails.motherID.trim()
        : "";
    const districtNameFromMap =
      inboundDetails.districtId && map?.Districts?.[inboundDetails.districtId]
        ? map.Districts[inboundDetails.districtId].name
        : "";
    const createPayload = { user };

    if (motherID && motherID !== "inbound-random") {
      createPayload.mother = {
        motherID,
        name: inboundDetails.name || "",
        contact: inboundDetails.contact || "",
        districtId: inboundDetails.districtId || null,
        districtName: inboundDetails.districtName || districtNameFromMap || "",
      };
    }

    // console.log("Creating new inbound case with payload: ", createPayload);

    axios
      .post(API_HOST_CRM + "/create-new-inbound-case", createPayload)
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setData([resp.data.case, ...data]);
          // if(selectedData?.inbound) {

          // }
          // setEcd({
          //     connectivityStatus: 'Connected'
          // })
          setSelectedData(resp.data.case);

          // also this is a callback which means the ui won't have the latest state why why why
          if (cb) {
            // we need to see if the formD has motherId or not otherwise,
            // we will send the resp.data.case.motherID
            // Here formD doesn't mean the state of formData2, i repeat it does not mean that
            // it is being passed in from a component
            // formD means when we are updating this inbound case, the data that is already there
            // i repeat it is not the current formData state
            // and when creating a new newInboundCase, we are not passing any parameters
            // get the data from formData2, hopefully. this code is a mess

            // NOTE: this callback is for when we are creatign a new inbound case
            // we are not passing any formD
            let condMotherID = "inbound-random"; // this is actually what is being saved in the database when are creating a new one

            // We should use formD since it contains latest data instead of the state
            if (formD?.motherID) {
              condMotherID = formD.motherID;
            } else {
              condMotherID = resp.data.case.motherID;
            }

            // if (formData2?.motherID) {
            //   condMotherID = formData2.motherID;
            // } else {
            //   condMotherID = resp.data.case.motherID;
            // }

            console.log("whats the mother id", condMotherID);
            // okk we need to do one thing, if this condMotherId is not inbound-random
            // lets pass the formData2 as teh formD

            let properFormD = formD;
            //
            if (condMotherID !== "inbound-random") {
              properFormD = formD;
            } else {
              properFormD = formData2;
            }

            console.log(`[CallerView.createNewInboundCase] district information: `, properFormD.districtId);
            console.log(`[CallerView.createNewInboundCase] properFormD: `, properFormD);

            // cb(resp.data.case._id, condMotherID, formD);

            // because this a callback, the ui won't update aahhhhh
            // why don't we just call the saveMotherDetails, that would save the hassle
            // we need to make sure this callback runs and the ui data sidebar updates
            cb(resp.data.case._id, condMotherID, properFormD);

            // need to clear the formData2 as well
            // cause why not
            setFormData2({});
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  /**
   * Right now the cb function is the saveMotherDetails method;
   *
   * This function is not being used right now. will save it when we need to do async await again
   */
  const createNewInboundCaseTest = async (cb, formD) => {
    try {
      const newInboundCaseResponse = await axios.post(
        API_HOST_CRM + "/create-new-inbound-case",
        {
          user,
        }
      );

      if (newInboundCaseResponse.data && newInboundCaseResponse.data.success) {
        setData([newInboundCaseResponse.data.case, ...data]);
        // if(selectedData?.inbound) {

        // }
        // setEcd({
        //     connectivityStatus: 'Connected'
        // })
        setSelectedData(newInboundCaseResponse.data.case);

        // we will not be using callback, we will be calling saveMotherDetails here and now
        // we don't do callbacks here.

        let condMotherID = "inbound-random"; // this is actually what is being saved in the database when are creating a new one
        if (formData2?.motherID) {
          condMotherID = formData2.motherID;
        } else {
          condMotherID = createNewInboundCase().data.case.motherID;
        }

        console.log("whats the mother id", condMotherID);
        // okk we need to do one thing, if this condMotherId is not inbound-random
        // lets pass the formData2 as teh formD

        let properFormD = formD;
        //
        if (condMotherID !== "inbound-random") {
          properFormD = formData2;
        } else {
          properFormD = formD;
        }

        // cb(resp.data.case._id, condMotherID, formD);

        // call saveMotherDetails right here instead of using callback
        // do this when cb is defined
        if (cb) {
          await saveMotherDetailsAsync(
            newInboundCaseResponse.data.case._id,
            condMotherID,
            properFormD
          );
        }
        // need to clear the formData2 as well
        // cause why not
        setFormData2({});
      }
    } catch (e) { }
    // convert this into async await
  };

  console.log("hello user", user);
  let updateStatusCount = 0;
  const updateStatus = async (id, status, selectedDay, reattempt) => {
    console.log(id, status, selectedDay, "whats your id, status, selectedDay");
    updateStatusCount++;
    console.log("update status count: ", updateStatusCount);
    await axios
      .put(API_HOST_CRM + "/cases-update-status", {
        id,
        status,
        callDate: selectedDay,
        reattempt: reattempt ? true : false,
        // ...(status !== "Active" && { user: user._id }), //user_id: user._id
      })
      .then((resp) => {
        console.log("response after updating", resp.data);
        if (resp.data && resp.data.success) {
          let newData = [...data];
          const index = newData.findIndex((e) => e._id == id);

          if (resp.data.rescheduled) {
            let dataFiltered = newData.filter((item) => {
              return item._id !== id;
            });

            setData([...dataFiltered]);
          } else {
            newData[index] = { ...resp.data.data };

            setData(newData);
            setSelectedData({
              ...newData[index],
              isGroup: selectedData?.isGroup.map((e) => {
                if (e._id == newData[index]._id) {
                  return newData[index];
                }
                return e;
              }),
            });
          }
        }
      })
      .catch((e) => {
        toast.error("Something went wrong.", {
          position: "top-center",
        });
        handleCloseReattemptModal();
        setIsUpdatingStatus(false);
        console.log("update status error", e);
      });
  };

  /**
   *  This is the transaction based methods to make sure case and ecd are both created and if not created then let the agent click save again.
   *
   *  props will be in the shape:
   * {
   *  caseRelated: {},
   *  ecdRelated: {}
   * }
   */
  const updateStatusAndSaveECD = async (props) => {
    updateStatusCount++;
    console.log("update status count: ", updateStatusCount);
    try {
      // we are using hope that props will have the properties we required
      let { id, status, selectedDay, reattempt } = props.caseRelated;
      let { localFormData, forType } = props.ecdRelated;

      // need to do some changes for the ecd payload
      if (localFormData.age) {
        localFormData.age = parseInt(localFormData.age);
      }
      if (localFormData.week) {
        localFormData.week = parseInt(localFormData.week);
      }

      let inboundCheck = selectedData?.inbound;
      let callType = "Outbound";
      if (inboundCheck) {
        if (localFormData.inboundCallType) {
          callType = localFormData.inboundCallType;
        } else {
          callType = "Inbound";
        }
      }

      let formDataForECD = {
        ...localFormData,
        caseId: selectedData._id,
        agent: selectedData.allocatedToUser,
        callDate: selectedData.callDate,
        bName: selectedData.name,
        motherID: selectedData.motherID,
        mNumber: selectedData.contact,
        district: selectedData.districtName,
        callType: callType,
        reattempt: forType === "reattempt" ? true : false,
      };

      if (forType) {
        if (forType === "reattempt") {
          formDataForECD.callDate = localFormData.callDate;
        }
      }

      const caseUpdateResponse = await axios.put(
        API_HOST_CRM + "/cases-update-status-and-save-ecd",
        {
          id,
          status,
          callDate: selectedDay,
          reattempt: reattempt ? true : false,
          data: formDataForECD,
          ...(ecd ? { ecd_id: ecd._id } : {}),
          ...(status === "Schedule Later" && {
            scheduledDate: localFormData.scheduledDate,
            scheduledLaterReason: localFormData?.scheduledLaterReason || null,
          }),
          // ...(status !== "Active" && { user: user._id }), //user_id: user._id
        }
      );

      console.log("response after updating", caseUpdateResponse.data);
      if (caseUpdateResponse.data && caseUpdateResponse.data.success) {
        let newData = [...data];
        let index = newData.findIndex((e) => e._id == id);

        // if we can find the index which means it should be an inbound case
        // then we push it in the new data array

        if (index !== -1) {
          console.log("Could not find index.");
          newData[index] = { ...caseUpdateResponse.data.data };
        }

        // then we get the index of it
        index = newData.findIndex((e) => e._id == id);

        if (caseUpdateResponse.data.rescheduled) {
          let dataFiltered = newData.filter((item) => {
            return item._id !== id;
          });

          setData([...dataFiltered]);
        } else {
          newData[index] = { ...caseUpdateResponse.data.data };
          console.log("selecteddata", selectedData);

          setData(newData);
          setSelectedData({
            ...newData[index],
            isGroup:
              selectedData?.isGroup?.map((e) => {
                if (e._id == newData[index]._id) {
                  return newData[index];
                }
                return e;
              }) || [],
          });
        }

        setEcd(caseUpdateResponse.data.ecd);
        setSavedN("ECD status & data saved successfully.");
        setECDFormErrors({});

        setSavingEcd(false);
      }
    } catch (error) {
      toast.error("Something went wrong.", {
        position: "top-center",
      });
      handleCloseReattemptModal();
      setIsUpdatingStatus(false);
      setSavingEcd(false);
      console.log("update status error", error);
    } finally {
      handleCloseReattemptModal();
      setIsUpdatingStatus(false);
      setSavingEcd(false);
    }
  };

  const connectedStatusHandler = async () => {
    let today = dayjs();
    setIsUpdatingStatus(true);
    // first saving the status
    // updateStatus last paremeter is reattempt value which will be sent to the backend
    let reattemptStatus = true;

    let localFormData = cloneDeep(formData);
    localFormData.callDate = dayjs();
    setIsUpdatingStatus(true);
    await updateStatusAndSaveECD({
      caseRelated: {
        id: selectedData._id,
        status: formData.callStatus,
        selectedDay: today,
        reattempt: false,
      },
      ecdRelated: {
        localFormData,
        forType: "",
      },
    });
  };

  const callStatusButtonHandler = async () => {
    try {
      // This is for updating the error state
      onChange(formData);
      // ECD FORM LOGIC
      const errorss = ecdFormErrorsLogic(formData);

      // saving for not connected and not in the portal should not involved
      // rest of the errros
      // Not Connected && Not in the portal
      // if both values don't exists that means both are set
      if (formData.callStatus && formData.connectivityStatus) {
        if (
          formData.callStatus &&
          formData.connectivityStatus === "Not Connected"
        ) {
          // ok before this we are gonna do some cool check
          let constantsForModalShowing = [
            "No answer",
            "Busy",
            "No network",
            "Invalid",
            "Incoming not available",
            "Call Incomplete",
            "Switched off",
            "Out of service",
          ];

          // need to check if callStatus is in the constantsForModalShowing array
          if (constantsForModalShowing.includes(formData.callStatus)) {
            // setOpenReattemptModal(true);
            handleReattemptSameDay();
            return;
          }

          // if (
          //   formData.callStatus == "Call done" ||
          //   true
          // ) {
          //   saveEcd(formData);
          // }

          // return early
          // return;
        }
      }

      //this will check if the fields are empty
      if (Object.keys(errorss).length !== 0) {
        console.log("form errors", errorss);
        // we still return because there might be other errors
        return;
      }

      // DO THIS AFTER THE MODAL LOGIC
      // There will be errors even if the callStatus and connectivity status are defined
      // so we save it none the less
      // updateStatus(
      //   selectedData._id,
      //   formData.callStatus,
      // );

      // reaching here means call done or connected status lets go
      connectedStatusHandler();
      return;
    } catch (error) {
      toast.error("Something went wrong.", {
        position: "top-center",
      });
    }
  };

  const handleCall = async (data, recall = false) => {
    const { contact } = data;
    if (loginObj) {
      setIsCallingCrm(true);
      // NOTE: This api is deprecated
      // axios
      //   .get(
      //     `https://in1-ccaas-api.ozonetel.com/CAServices/AgentManualDial.php?format=json&api_key=${apiKey}&username=${Customer}&agentID=${loginObj.agentId}&campaignName=${loginObj.campaign}&customerNumber=${contact}&&uui=${data._id}`
      //   )
      //   .then(async (resp) => {
      //     // console.log('Test call', resp.data)
      //     if (resp.data?.status) {
      //       //'Agent is not available',
      //       const fail = ["Campaign is invalid"];
      //       console.log("--->", resp.data.status);
      //       if (fail.includes(resp.data.status)) {
      //         //CHANGE
      //         alert("The campaign is invalid please check the campaign");
      //       } else if (!recall) {
      //         await updateStatus(selectedData._id, "Active", dayjs());
      //       }
      //     }
      //   })
      //   .catch((e) => {
      //     console.log(e);
      //   })
      //   .finally(() => {
      //     setIsCallingCrm(false);
      //   });

      // NEW POST ROUTE
      axios
        .post(
          `https://in1-ccaas-api.ozonetel.com/ca_apis/AgentManualDial`,
          {
            userName: Customer,
            agentID: loginObj.agentId,
            campaignName: loginObj.campaign,
            customerNumber: contact,
            uui: data._id,
          },
          {
            headers: {
              "apiKey": apiKey,
              "Content-Type": "application/json"
            }
          }
        )
        .then(async (resp) => {
          // console.log('Test call', resp.data)
          if (resp.data?.status) {
            //'Agent is not available',
            const successStatus = ["queued successfully"];
            console.log("--->", resp.data.status);
            if (!successStatus.includes(resp.data.status)) {
              //CHANGE
              alert("The campaign is invalid please check the campaign");
              console.log(`[CallerView.handleCall] resp`, resp);
            } else if (!recall) {
              await updateStatus(selectedData._id, "Active", dayjs());
            }
          }
        })
        .catch(async (e) => {
          console.log(`[CallerView.handleCall.catchblock], error:`, e);
          // TODO: LOCAL Development
          // await updateStatus(selectedData._id, "Active", dayjs());
          // return;
          // We need to check for the specific message of "Agent is not available" 
          // Because that message also comes when the agent is in a call
          // According to the documentation this message also comes when the agent is not available
          // or not logged in
          if (e.response && e.response.data && e.response.data.message) {
            if (e.response.data.message === "Agent is not available") {
              console.log("Agent is not available", e);
              // We will update the status to Active only if it is not a recall
              if (!recall) {
                await updateStatus(selectedData._id, "Active", dayjs());
              }
            }
          }
        })
        .finally(() => {
          setIsCallingCrm(false);
        });

    }
  };

  const [viewPreviousECD, setViewPreviousECD] = useState(false);

  console.log(selectedData, "onclick value");
  const handleSingleFromGroup = (arg) => {
    setSelectedData({ ...arg, isGroup: selectedData?.isGroup });
    setCurrentStatus(null);
    setECDFormErrors({});
    // console.log(selectedData,'onclick value');
    // let newAray = selectedData?.isGroup.map((item)=> {
    //     if (item._id === arg._id) {
    //         item['isSelected'] = true
    //         return item
    //     }
    // })
    // console.log(newAray, 'get new array');
  };

  return (
    <>
      {notification && (
        <Notice
          type="warning"
          text={notification}
          onClose={() => {
            setNotification(null);
          }}
        >
          <CallIcon />
        </Notice>
      )}

      {savedN && (
        <Notice
          type="success"
          text={savedN}
          onClose={() => {
            setSavedN(null);
          }}
        >
          <CallIcon />
        </Notice>
      )}
      <FullScreenLoader open={isUpdatingStatus} />
      <Box sx={{ display: "flex" }}>
        <Box sx={{ width: "70%" }}>
          <Box sx={{ mt: 2 }}>
            <Box sx={{ display: "flex" }}>
              <Sidebar
                data={data}
                selected={selectedData}
                onChange={(d, group) => {
                  setFormData2({});
                  setFormData({});
                  // console.log({ ...d, isGroup: groupMothers }, 'selected data');
                  // setSelectedData(d)
                  setSelectedData({ ...d, isGroup: group });
                  setCurrentStatus(null);
                }}
              />

              <Box sx={{ width: "75%", overflow: "scroll", height: "80vh" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      width: "95%",
                      border: "1px solid #e5efff",
                      pb: 5,
                      height: "auto",
                    }}
                  >
                    {!selectedData && (
                      <Box
                        sx={{
                          borderBottom: "1px solid #e5efff",
                          display: "flex",
                          justifyContent: "flex-end",
                          padding: "5px 10px 5px 10px",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          sx={{ ml: 2 }}
                          onClick={() => {
                            // createNewInboundCase
                            setInboundAction("new");
                            setOpen(true);
                            setFormData2({
                              motherID: "",
                              name: "",
                              contact: "",
                              districtId: "",
                            });
                          }}
                        >
                          New Inbound
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          sx={{ ml: 2, fontSize: ".6em", height: "1.8em" }}
                          onClick={() => {
                            setOpenLogin(true);
                            setLoginData({ ...loginObj } || {});
                          }}
                        >
                          Ozontel
                        </Button>
                      </Box>
                    )}
                    {selectedData && (
                      <>
                        <Box
                          sx={{
                            borderBottom: "1px solid #e5efff",
                            display: "flex",
                            justifyContent: "flex-end",
                            padding: "5px 10px 5px 10px",
                            alignItems: "center",
                          }}
                        >
                          <Button
                            variant="outlined"
                            size="small"
                            sx={{ ml: 2, fontSize: ".6em", height: "1.8em" }}
                            onClick={() => {
                              setOpenLogin(true);
                              setLoginData({ ...loginObj } || {});
                            }}
                          >
                            Ozontel
                          </Button>
                        </Box>
                        {/* group mother information */}
                        {/* {
                                                    !ifGroup && */}
                        {/* if call done tick mark will show , if not it will be blank , is selected on that mother id of group it will be highlighted with orange color */}
                        <Box>
                          <Typography variant="h5" sx={{ color: "#F28627" }}>
                            {" "}
                            Group: {selectedData?.contact}
                          </Typography>
                          <div className="d-flex flex-wrap">
                            {selectedData?.isGroup?.map((r, i) => (
                              <Chip
                                key={i}
                                sx={{
                                  color: "#000",
                                  margin: 1,
                                  backgroundColor:
                                    selectedData._id == r._id && "#F28627",
                                }}
                                icon={
                                  completedStatus.includes(r.status) && (
                                    <TaskAltIcon sx={{ color: "#fff" }} />
                                  )
                                }
                                label={r.name}
                                onClick={(e) => {
                                  console.log(r, "click value");
                                  handleSingleFromGroup(r);
                                }}
                              />
                            ))}
                          </div>
                        </Box>
                        {/* } */}
                        {/* group mother information */}

                        <Box
                          sx={{
                            borderBottom: "1px solid #e5efff",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "5px 10px 5px 10px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              variant="h5"
                              sx={{ textAlign: "center", color: "#375674" }}
                            >
                              {" "}
                              {`#${selectedData.motherID}`}
                            </Typography>
                            {/* RE-CALL */}
                            {selectedData.status === "Pending" &&
                              selectedData.rescheduled && (
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  alignItems="center"
                                  sx={{
                                    backgroundColor: "background.paper",
                                    p: 1.2,
                                    borderRadius: 1,
                                    "&:hover": {
                                      backgroundColor: "action.hover",
                                    },
                                  }}
                                >
                                  <CalendarTodayIcon
                                    sx={{ color: "primary.main" }}
                                  />
                                  <Typography
                                    variant="body1"
                                    sx={{
                                      color: "text.body2",
                                      fontWeight: 500,
                                    }}
                                  >
                                    Re-call Date:{" "}
                                    {dayjs(selectedData.callDate).format(
                                      "dddd, MMMM D, YYYY"
                                    )}
                                  </Typography>
                                </Stack>
                              )}
                          </Box>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            {selectedData.status == "Pending" && (
                              <Chip
                                sx={{
                                  color: "#ffbb00",
                                  borderColor: "#ffbb00",
                                  [`& .${chipClasses.icon}`]: {
                                    color: "#ffbb00",
                                  },
                                }}
                                icon={<PendingIcon />}
                                label="Upcoming"
                                variant="outlined"
                              />
                            )}
                            {selectedData.status == "Active" && (
                              <Chip
                                sx={{
                                  color: "#00c48c",
                                  borderColor: "#00c48c",
                                  [`& .${chipClasses.icon}`]: {
                                    color: "#00c48c",
                                  },
                                }}
                                icon={<CheckCircleIcon />}
                                label="Ongoing"
                                variant="outlined"
                              />
                            )}
                            {!["Active", "Pending"].includes(
                              selectedData.status
                            ) && (
                                <Chip
                                  sx={{
                                    color: "#0265ff",
                                    borderColor: "#0265ff",
                                    [`& .${chipClasses.icon}`]: {
                                      color: "#0265ff",
                                    },
                                  }}
                                  icon={<DoneAllIcon />}
                                  label={selectedData.status}
                                  variant="outlined"
                                />
                              )}
                            <Typography
                              variant="p"
                              sx={{
                                ml: 2,
                                textAlign: "center",
                                color: "#375674",
                              }}
                            >
                              {" "}
                              {`Attempted: (${selectedData.attempt || 0})`}
                            </Typography>
                            <Button
                              variant="contained"
                              sx={{ ml: 2 }}
                              onClick={() => {
                                setInboundAction("new");
                                setOpen(true);
                                setFormData2({
                                  motherID: "",
                                  name: "",
                                  contact: "",
                                  districtId: "",
                                });
                              }}
                            >
                              New Inbound
                            </Button>
                            {selectedData.status == "Active" && (
                              <Button
                                variant="outlined"
                                sx={{ ml: 2 }}
                                onClick={() => {
                                  setOpenNewCase(true);
                                }}
                              >
                                New Case
                              </Button>
                            )}
                          </Box>
                          {/* {
                                                    selectedData.status == 'Bad Data'&&
                                                    <Chip sx={{color: '#ff4651', borderColor:'#ff4651',
                                                        [`& .${chipClasses.icon}`]: {
                                                          color: "#ff4651"
                                                        }
                                                       }} icon={<DangerousIcon />} label="Bad Data" variant="outlined" />
                                                } */}
                        </Box>

                        {/* by Rupon  */}
                        <div className="m-2 p-2">
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Box>
                              Mother Profile
                              {(selectedData.motherID == "inbound-random" ||
                                selectedData.inbound) &&
                                selectedData.status === "Active" && (
                                  <Button
                                    onClick={() => {
                                      setInboundAction("edit");
                                      setOpen(true);
                                      setFormData2({
                                        motherID: selectedData?.motherID || "",
                                        name: selectedData?.name || "",
                                        contact: selectedData?.contact || "",
                                        districtId:
                                          selectedData?.districtId || "",
                                      });
                                    }}
                                  >
                                    Edit
                                  </Button>
                                )}
                              {selectedData.inbound &&
                                selectedData.status === "Active" && (
                                  <Button
                                    onClick={() => {
                                      deleteInboundCase(selectedData._id);
                                    }}
                                  >
                                    Delete
                                  </Button>
                                )}
                            </Box>
                            <Box>
                              {selectedData.inbound && (
                                <Chip label={"Inbound"} variant="outlined" />
                              )}
                            </Box>
                          </Box>
                          <div className="row ">
                            <div className="col-md-6 p-1">
                              <Box
                                sx={{ padding: 1, border: ".5px solid grey" }}
                              >
                                <Typography
                                  variant="p"
                                  sx={{ color: "#577592", fontSize: ".8em" }}
                                >
                                  Name:{" "}
                                  <span
                                    style={{
                                      color: "#375674",
                                      fontSize: "1.2em",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {selectedData.name}{" "}
                                  </span>
                                </Typography>
                              </Box>
                            </div>
                            <div className="col-md-6 p-1">
                              <Box
                                sx={{ padding: 1, border: ".5px solid grey" }}
                              >
                                <Typography
                                  variant="p"
                                  sx={{ color: "#577592", fontSize: ".8em" }}
                                >
                                  District:{" "}
                                  <span
                                    style={{
                                      color: "#375674",
                                      fontSize: "1.2em",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {selectedData.districtName}
                                  </span>{" "}
                                </Typography>
                              </Box>
                            </div>
                            <div className="col-md-6 p-1">
                              <Box
                                sx={{ padding: 1, border: ".5px solid grey" }}
                              >
                                <Typography
                                  variant="p"
                                  sx={{ color: "#577592", fontSize: ".8em" }}
                                >
                                  Contact:{" "}
                                  <span
                                    style={{
                                      color: "#375674",
                                      fontSize: "1.2em",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {selectedData.contact}
                                  </span>
                                </Typography>
                              </Box>
                            </div>
                            <div className="col-md-6 p-1">
                              <Box
                                sx={{ padding: 1, border: ".5px solid grey" }}
                              >
                                <Typography
                                  variant="p"
                                  sx={{ color: "#577592", fontSize: ".8em" }}
                                >
                                  Call status:{" "}
                                  <span
                                    style={{
                                      color: "#375674",
                                      fontSize: "1.2em",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {selectedData.status}
                                  </span>
                                </Typography>
                              </Box>
                            </div>
                          </div>
                        </div>

                        {oldEcd.at(-1) &&
                          selectedData.motherID != "inbound-random" && (
                            <div className="p-3 bg-light">
                              {console.log(
                                "ohoohoo",
                                oldEcd.at(-1).pregnancyStatus
                              )}
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Typography
                                  variant="h5"
                                  sx={{ color: "#375674" }}
                                >
                                  {" "}
                                  Previous report
                                </Typography>
                                {oldEcd.at(-1)?.agent?.name && (
                                  <>
                                    <Typography
                                      variant="h5"
                                      sx={{ color: "#375674" }}
                                    >
                                      :
                                    </Typography>
                                    <Typography
                                      variant="p"
                                      sx={{ color: "#577592" }}
                                    >
                                      &nbsp;by
                                    </Typography>
                                    <Typography
                                      variant="h5"
                                      sx={{ color: "#577592" }}
                                    >
                                      &nbsp;
                                      {oldEcd.at(-1)?.agent?.name}
                                    </Typography>
                                  </>
                                )}
                              </Box>
                              <hr />
                              <div className="row">
                                <div className="col-md-6 pb-3">
                                  Pregnancy Status:{" "}
                                  <strong>
                                    {oldEcd.at(-1).pregnancyStatus}
                                  </strong>
                                </div>
                                <div className="col-md-6 pb-3">
                                  Pregnancy Month:{" "}
                                  <strong>
                                    {oldEcd.at(-1).pregnancyMonth}
                                  </strong>
                                </div>
                                <div className="col-md-6 pb-3">
                                  Week: <strong>{oldEcd.at(-1).week}</strong>
                                </div>
                                <div className="col-md-6 pb-3">
                                  Trimester:{" "}
                                  <strong>{oldEcd.at(-1).trimester}</strong>
                                </div>
                                <div className="col-md-6 pb-3">
                                  ICDS Status:{" "}
                                  <strong>
                                    {oldEcd.at(-1).ICDSSchemeStatus || ""}
                                  </strong>
                                </div>
                                <div className="col-md-6 pb-3">
                                  Place of Birth:{" "}
                                  <strong>
                                    {oldEcd.at(-1).childDeliveryPlace}
                                  </strong>
                                </div>
                                <div className="col-md-6 pb-3">
                                  Children under 1 year:{" "}
                                  <strong>{oldEcd.at(-1).lessThen1Year}</strong>
                                </div>
                                <div className="col-md-6 pb-3">
                                  Children from 1 to 2 year:{" "}
                                  <strong>{oldEcd.at(-1).between1And2}</strong>
                                </div>
                                <div className="col-md-6 pb-3">
                                  Advice:{" "}
                                  <strong>{oldEcd.at(-1).advice}</strong>
                                </div>
                                <div className="col-md-6 pb-3">
                                  Alternate Number:{" "}
                                  <strong>
                                    {oldEcd.at(-1).alternateNumber || ""}
                                  </strong>
                                </div>
                              </div>

                              <div className="text-center">
                                <Button
                                  onClick={(e) =>
                                    viewPreviousECD
                                      ? setViewPreviousECD(false)
                                      : setViewPreviousECD(true)
                                  }
                                >
                                  {viewPreviousECD
                                    ? "Hide All Records"
                                    : "View All Records"}{" "}
                                </Button>
                              </div>
                            </div>
                          )}

                        {viewPreviousECD &&
                          selectedData.motherID != "inbound-random" && (
                            <div className="last-record">
                              <Box sx={{ width: "100%", p: 2 }}>
                                <Typography>Previous all Reports:</Typography>
                                {oldEcd.length > 0 && (
                                  <Box>
                                    {oldEcd.map((e, i) => {
                                      return (
                                        <Accordion
                                          key={i}
                                          expanded={expanded === `panel${i}`}
                                          onChange={handleChange(`panel${i}`)}
                                        >
                                          <AccordionSummary
                                            aria-controls="panel1d-content"
                                            id="panel1d-header"
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                width: "100%",
                                              }}
                                            >
                                              <Typography>
                                                {" "}
                                                {`${i == oldEcd.length - 1
                                                  ? "Last "
                                                  : i == 0
                                                    ? "1st"
                                                    : i == 1
                                                      ? "2nd"
                                                      : i == 2
                                                        ? "3rd"
                                                        : `${i + 1}th`
                                                  }`}{" "}
                                                Call{" "}
                                              </Typography>
                                              <Box>
                                                <Typography>
                                                  Caller: {e.agent?.name || ""}
                                                </Typography>
                                              </Box>
                                              <Box>
                                                <Typography>
                                                  on:{" "}
                                                  {dayjs(e.callDate).format(
                                                    "DD-MM-YYYY"
                                                  )}
                                                </Typography>
                                              </Box>
                                            </Box>
                                          </AccordionSummary>
                                          <AccordionDetails>
                                            <Box>
                                              <Box
                                                sx={{
                                                  padding: 1,
                                                  border: ".5px solid grey",
                                                }}
                                              >
                                                <Typography
                                                  variant="p"
                                                  sx={{
                                                    color: "#577592",
                                                    fontSize: ".8em",
                                                  }}
                                                >
                                                  Pregnancy Status :{" "}
                                                  <span
                                                    style={{
                                                      color: "#375674",
                                                      fontSize: "1.2em",
                                                    }}
                                                  >
                                                    {e.pregnancyStatus}{" "}
                                                  </span>
                                                </Typography>
                                              </Box>
                                              <Box
                                                sx={{
                                                  padding: 1,
                                                  border: ".5px solid grey",
                                                }}
                                              >
                                                <Typography
                                                  variant="p"
                                                  sx={{
                                                    color: "#577592",
                                                    fontSize: ".8em",
                                                  }}
                                                >
                                                  Week :{" "}
                                                  <span
                                                    style={{
                                                      color: "#375674",
                                                      fontSize: "1.2em",
                                                    }}
                                                  >
                                                    {e.week}{" "}
                                                  </span>
                                                </Typography>
                                              </Box>
                                              <Box
                                                sx={{
                                                  padding: 1,
                                                  border: ".5px solid grey",
                                                }}
                                              >
                                                <Typography
                                                  variant="p"
                                                  sx={{
                                                    color: "#577592",
                                                    fontSize: ".8em",
                                                  }}
                                                >
                                                  Month:{" "}
                                                  <span
                                                    style={{
                                                      color: "#375674",
                                                      fontSize: "1.2em",
                                                    }}
                                                  >
                                                    {e.pregnancyMonth}
                                                  </span>{" "}
                                                </Typography>
                                              </Box>
                                              <Box
                                                sx={{
                                                  padding: 1,
                                                  border: ".5px solid grey",
                                                }}
                                              >
                                                <Typography
                                                  variant="p"
                                                  sx={{
                                                    color: "#577592",
                                                    fontSize: ".8em",
                                                  }}
                                                >
                                                  Trimester:{" "}
                                                  <span
                                                    style={{
                                                      color: "#375674",
                                                      fontSize: "1.2em",
                                                    }}
                                                  >
                                                    {e.trimester}
                                                  </span>
                                                </Typography>
                                              </Box>
                                              <Box
                                                sx={{
                                                  padding: 1,
                                                  border: ".5px solid grey",
                                                }}
                                              >
                                                <Typography
                                                  variant="p"
                                                  sx={{
                                                    color: "#577592",
                                                    fontSize: ".8em",
                                                  }}
                                                >
                                                  ICDS Scheme status :{" "}
                                                  <span
                                                    style={{
                                                      color: "#375674",
                                                      fontSize: "1.2em",
                                                    }}
                                                  >
                                                    {e.ICDSSchemeStatus || ""}{" "}
                                                  </span>
                                                </Typography>
                                              </Box>

                                              <Box
                                                sx={{
                                                  padding: 1,
                                                  border: ".5px solid grey",
                                                }}
                                              >
                                                <Typography
                                                  variant="p"
                                                  sx={{
                                                    color: "#577592",
                                                    fontSize: ".8em",
                                                  }}
                                                >
                                                  Advice:
                                                  <span
                                                    style={{
                                                      color: "#375674",
                                                      fontSize: "1.2em",
                                                    }}
                                                  >
                                                    {" "}
                                                    {e.advice}
                                                  </span>
                                                </Typography>
                                              </Box>
                                              <Box
                                                sx={{
                                                  padding: 1,
                                                  border: ".5px solid grey",
                                                }}
                                              >
                                                <Typography
                                                  variant="p"
                                                  sx={{
                                                    color: "#577592",
                                                    fontSize: ".8em",
                                                  }}
                                                >
                                                  Alternate Number :{" "}
                                                  <span
                                                    style={{
                                                      color: "#375674",
                                                      fontSize: "1.2em",
                                                    }}
                                                  >
                                                    {e.alternateNumber || ""}{" "}
                                                  </span>
                                                </Typography>
                                              </Box>
                                            </Box>
                                          </AccordionDetails>
                                        </Accordion>
                                      );
                                    })}
                                  </Box>
                                )}
                              </Box>
                            </div>
                          )}
                        {true && (
                          <Box sx={{ width: "100%", p: 2 }}>
                            <Accordion
                              key={"number-change"}
                              expanded={numberChangeExpanded}
                              onChange={() => {
                                setNumberChangeExpanded(!numberChangeExpanded);
                              }}
                            >
                              <AccordionSummary
                                aria-controls="panel1d-content"
                                id="panel1d-header"
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                  }}
                                >
                                  <Typography sx={{ color: "#274073" }}>
                                    {" "}
                                    Alternate Number History{" "}
                                  </Typography>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Box>
                                  {oldEcd.length > 0 && (
                                    <Box>
                                      {oldEcd.map((e, i) => {
                                        return (
                                          <Box
                                            sx={{
                                              padding: 1,
                                              border: ".5px solid grey",
                                            }}
                                          >
                                            <Typography
                                              variant="p"
                                              sx={{
                                                color: "#577592",
                                                fontSize: ".8em",
                                              }}
                                            >
                                              on:{" "}
                                              {dayjs(e.callDate).format(
                                                "DD-MM-YYYY"
                                              )}{" "}
                                              :{" "}
                                              <span
                                                style={{
                                                  color: "#375674",
                                                  fontSize: "1.2em",
                                                }}
                                              >
                                                {e.alternateNumber || "Nil"}{" "}
                                              </span>
                                            </Typography>
                                          </Box>
                                        );
                                      })}
                                    </Box>
                                  )}
                                </Box>
                              </AccordionDetails>
                            </Accordion>
                          </Box>
                        )}

                        {/* by Rupon  */}

                        {/* <Box sx={{ padding: '20px', display: 'flex' }}>
                                                    <Box sx={{ width: '35%' }}>
                                                        <Typography>Mother Profile:</Typography>
                                                        <Box sx={{ padding: 1, border: '.5px solid grey' }}><Typography variant='p' sx={{ color: '#577592', fontSize: '.8em' }}>Name: <span style={{ color: '#375674', fontSize: '1.2em' }}>{selectedData.name} </span></Typography></Box>
                                                        <Box sx={{ padding: 1, border: '.5px solid grey' }}><Typography variant='p' sx={{ color: '#577592', fontSize: '.8em' }}>District: <span style={{ color: '#375674', fontSize: '1.2em' }}>{selectedData.districtName}</span> </Typography></Box>
                                                        <Box sx={{ padding: 1, border: '.5px solid grey' }}><Typography variant='p' sx={{ color: '#577592', fontSize: '.8em' }}>Contact: <span style={{ color: '#375674', fontSize: '1.2em' }}>{selectedData.contact}</span></Typography></Box>
                                                        <Box sx={{ padding: 1, border: '.5px solid grey' }}><Typography variant='p' sx={{ color: '#577592', fontSize: '.8em' }}>Call status: <span style={{ color: '#375674', fontSize: '1.2em' }}>{selectedData.status}</span></Typography></Box>

                                                    </Box>



                                                    <Box sx={{ width: '65%', ml: 2 }}>
                                                        <Typography>Previous Reports:</Typography>
                                                        {
                                                            oldEcd.length > 0 &&
                                                            <Box>
                                                                {
                                                                    oldEcd.map((e, i) => {
                                                                        return (
                                                                            <Accordion key={i} expanded={expanded === `panel${i}`} onChange={handleChange(`panel${i}`)} >
                                                                                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                                        <Typography> {`${i == oldEcd.length - 1 ? 'Last ' : i == 0 ? '1st' : i == 1 ? '2nd' : i == 2 ? '3rd' : `${i + 1}th`}`} Call </Typography>
                                                                                        <Box><Typography>on: {dayjs(e.callDate).format('DD-MM-YYYY')}</Typography></Box>
                                                                                    </Box>
                                                                                </AccordionSummary>
                                                                                <AccordionDetails>
                                                                                    <Box>
                                                                                        <Box sx={{ padding: 1, border: '.5px solid grey' }}><Typography variant='p' sx={{ color: '#577592', fontSize: '.8em' }}>
                                                                                            Week : <span style={{ color: '#375674', fontSize: '1.2em' }}>{e.week} </span></Typography></Box>
                                                                                        <Box sx={{ padding: 1, border: '.5px solid grey' }}><Typography variant='p' sx={{ color: '#577592', fontSize: '.8em' }}>
                                                                                            Month: <span style={{ color: '#375674', fontSize: '1.2em' }}>{e.pregnancyMonth}</span> </Typography></Box>
                                                                                        <Box sx={{ padding: 1, border: '.5px solid grey' }}><Typography variant='p' sx={{ color: '#577592', fontSize: '.8em' }}>
                                                                                            Trimester: <span style={{ color: '#375674', fontSize: '1.2em' }}>{e.trimester}</span></Typography></Box>
                                                                                        <Box sx={{ padding: 1, border: '.5px solid grey' }}><Typography variant='p' sx={{ color: '#577592', fontSize: '.8em' }}>
                                                                                            Advice:
                                                                                            <span style={{ color: '#375674', fontSize: '1.2em' }}> {e.advice}</span></Typography></Box>

                                                                                    </Box>
                                                                                </AccordionDetails>
                                                                            </Accordion>
                                                                        )
                                                                    })
                                                                }
                                                            </Box>
                                                        }
                                                    </Box>


                                                </Box> */}

                        {selectedData && (
                          <Box
                            sx={{
                              mt: 4,
                              display: "flex",
                              justifyContent: "space-around",
                              padding: "6px 0px 6px 0px",
                              borderBottom: "1px solid #e5efff",
                              borderTop: "1px solid #e5efff",
                            }}
                          >
                            {(selectedData.status == "Pending" ||
                              (selectedData.attempt < 3 &&
                                [
                                  "No answer",
                                  "Busy",
                                  "No network",
                                  "Invalid",
                                  "Incoming not available",
                                  "Call Incomplete",
                                  "Switched off",
                                  "Out of service",
                                  "Declined",
                                ].includes(selectedData.status))) &&
                              loginObj && (
                                <Button
                                  variant="contained"
                                  onClick={() => {
                                    handleCall(selectedData);
                                  }}
                                  disabled={isCallingCrm}
                                >
                                  <CallIcon /> &nbsp;
                                  {isCallingCrm ? "Calling..." : "Call"}
                                </Button>
                              )}
                            {/* {
                                                            selectedData.status == 'Active' &&
                                                            <>
                                                                <Box sx={{ display: 'flex', width: '60%' }}>
                                                                    <SelectA field={
                                                                        {
                                                                            type: 'select',
                                                                            label: 'Status',
                                                                            option: { key: 'Status', value: '_id', label: 'name' },
                                                                            name: 'status',
                                                                            noMb: true
                                                                        }
                                                                    } data={{
                                                                        Status:
                                                                            ['No answer', 'Call done', 'Busy', 'No network', 'Invalid',
                                                                                'Incoming not available', 'Not in the portal',
                                                                                'Miscarriage', 'Call Incomplete', 'Deceased Child', 'Switched off', 'Wrong number', 'Declined',
                                                                                'Out of service', 'Language Barrier', 'Deceased Mother', 'Deceased (Mother and Child)', 'Duplicate Mother Id'
                                                                            ].map(d => ({ _id: d, name: d }))
                                                                    }} onChange={(name, value, multiple) => {
                                                                        setCurrentStatus(value)
                                                                    }} value={currentStatus} />

                                                                    <Button variant="contained" color="success" sx={{ ml: 2 }} onClick={() => {
                                                                        updateStatus(selectedData._id, currentStatus)
                                                                        if (currentStatus == 'Call done') {
                                                                            saveEcd(formData)
                                                                        }
                                                                    }}>Save</Button>
                                                                </Box>
                                                            </>
                                                        } */}

                            {selectedData.status == "Language Barrier" && (
                              <>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "60%",
                                  }}
                                >
                                  {/* SELECT:LANGUAGE */}
                                  <TextField
                                    select
                                    label="Select a Language"
                                    margin="dense"
                                    size="medium"
                                    fullWidth
                                    // InputLabelProps={{
                                    //   shrink: true,
                                    // }}
                                    value={language}
                                    onChange={(e) => {
                                      setLanguageError(false);
                                      setLanguage(e.target.value);
                                    }}
                                    // custom error logic
                                    error={languageError}
                                    helperText={
                                      languageError && "Please select language"
                                    }
                                  >
                                    {Languages.map((option) => (
                                      <MenuItem key={option} value={option._id}>
                                        {option.name}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                  {/* SELECT:LANGUAGE END */}
                                  <Button
                                    sx={{ ml: 2, mt: 1, mb: 1, pt: 1, pb: 1 }}
                                    variant="contained"
                                    onClick={() => {
                                      // const languageFind = Languages.find(
                                      //   (lang) => lang._id === language
                                      // );
                                      // console.log("lang find", languageFind);
                                      // if (!languageFind) {
                                      //   setLanguageError(true);
                                      //   return;
                                      // }

                                      if (!transfering) {
                                        tryTransferCase();
                                        setTransfering(true);
                                      }
                                    }}
                                  >
                                    <SendIcon /> &nbsp;
                                    {transfering
                                      ? "Transferring..."
                                      : "Transfer"}
                                  </Button>
                                </Box>
                              </>
                            )}

                            {selectedData.status == "Schedule Later" && (
                              <Box>
                                <Stack direction={"column"} gap={1}>
                                  <Stack
                                    direction={"column"}
                                    gap={0.5}
                                    alignItems={"center"}
                                    component={Paper}
                                    p={2}
                                  >
                                    <Typography
                                      variant="subtitle1"
                                      fontWeight="bold"
                                    >
                                      Scheduled Later
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      Scheduled Date:{" "}
                                      {dayjs(
                                        selectedData.scheduledLaterAt
                                      ).format("DD-MM-YYYY")}
                                    </Typography>
                                  </Stack>

                                  <Stack>
                                    {(selectedData.status == "Schedule Later" ||
                                      (selectedData.attempt < 3 &&
                                        [
                                          "No answer",
                                          "Busy",
                                          "No network",
                                          "Invalid",
                                          "Incoming not available",
                                          "Call Incomplete",
                                          "Switched off",
                                          "Out of service",
                                          "Declined",
                                        ].includes(selectedData.status))) &&
                                      loginObj && (
                                        <Button
                                          variant="contained"
                                          onClick={() => {
                                            handleCall(selectedData);
                                          }}
                                          disabled={
                                            isCallingCrm ||
                                            dayjs(
                                              selectedData.scheduledLaterAt
                                            ).isBefore(dayjs())
                                          }
                                        >
                                          <CallIcon /> &nbsp;
                                          {isCallingCrm ? "Calling..." : "Call"}
                                        </Button>
                                      )}
                                  </Stack>
                                </Stack>
                              </Box>
                            )}
                          </Box>
                        )}

                        {["Active"].includes(selectedData.status) && (
                          // || !['Pending', 'Call done', 'Language Barrier'].includes(selectedData.status) && !(['No answer', 'Busy', 'No network', 'Invalid',
                          //     'Incoming not available', 'Call Incomplete', 'Switched off', 'Out of service'].includes(selectedData.status))
                          <Box sx={{ p: 2 }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                mb: 2,
                                border: "1px solid #e5efff",
                                padding: "10px 20px 10px 20px",
                              }}
                            >
                              {!changePhone && (
                                <Box>
                                  <Typography
                                    variant="p"
                                    sx={{ color: "#375674", fontSize: "1em" }}
                                  >
                                    {" "}
                                    Contact Number: {selectedData.contact}
                                  </Typography>
                                </Box>
                              )}

                              {changePhone && (
                                <Box sx={{}}>
                                  <TextField
                                    type="text"
                                    margin="dense"
                                    label={"New Number"}
                                    value={newPhone}
                                    name={"week"}
                                    onChange={(e) =>
                                      setNewPhone(e.target.value)
                                    }
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    min={1}
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                  // onChange={(e) => { onChange(name, e.target.value, false, index) }}
                                  />
                                </Box>
                              )}
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Button
                                  variant="outlined"
                                  size="small"
                                  sx={{
                                    ml: 2,
                                    fontSize: ".6em",
                                    height: "1.8em",
                                  }}
                                  onClick={() => {
                                    if (changePhone) {
                                      if (newPhone) {
                                        changeToNewPhoneNumber();
                                      }
                                    } else {
                                      setChangePhone(!changePhone);
                                    }
                                  }}
                                >
                                  {changePhone ? "update" : "change"}
                                </Button>
                                {!changePhone && (
                                  <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                      ml: 2,
                                      fontSize: ".6em",
                                      height: "2.2em",
                                    }}
                                    onClick={() => {
                                      handleCall(selectedData, true);
                                    }}
                                  >
                                    {"Call"}
                                  </Button>
                                )}
                                {changePhone && (
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                      ml: 2,
                                      fontSize: ".6em",
                                      height: "1.8em",
                                    }}
                                    onClick={() => {
                                      setChangePhone(false);
                                    }}
                                  >
                                    cancel
                                  </Button>
                                )}
                              </Box>
                            </Box>
                            <EcdReportForm
                              errors={ECDFormErrors}
                              data={selectedData}
                              // this doesnt actually save right now
                              // save is being handle in the button next
                              onSubmit={saveEcd} // on submit is being handled here in view.js
                              ecd={ecd}
                              onChange={onChange}
                              currentStatus={currentStatus}
                            />

                            <div className="text-center">
                              {/* FORMSAVE */}
                              <Button
                                type="submit"
                                variant="contained"
                                color="success"
                                sx={{ ml: 2 }}
                                onClick={() => {
                                  // BUTTON CLICK HANDLER
                                  callStatusButtonHandler();
                                  // try {
                                  //   // This is for updating the error state
                                  //   onChange(formData);
                                  //   // ECD FORM LOGIC
                                  //   const errorss =
                                  //     ecdFormErrorsLogic(formData);

                                  //   // saving for not connected and not in the portal should not involved
                                  //   // rest of the errros
                                  //   // Not Connected && Not in the portal
                                  //   // if both values don't exists that means both are set
                                  //   if (
                                  //     formData.callStatus &&
                                  //     formData.connectivityStatus
                                  //   ) {
                                  //     if (
                                  //       formData.callStatus &&
                                  //       formData.connectivityStatus ===
                                  //       "Not Connected"
                                  //     ) {
                                  //       // ok before this we are gonna do some cool check
                                  //       let constantsForModalShowing = [
                                  //         "No answer",
                                  //         "Busy",
                                  //         "No network",
                                  //         "Invalid",
                                  //         "Incoming not available",
                                  //         "Call Incomplete",
                                  //         "Switched off",
                                  //         "Out of service",
                                  //       ];

                                  //       // need to check if callStatus is in the constantsForModalShowing array
                                  //       if (
                                  //         constantsForModalShowing.includes(
                                  //           formData.callStatus,
                                  //         )
                                  //       ) {
                                  //         // setOpenReattemptModal(true);
                                  //         handleReattemptSameDay();
                                  //         return;
                                  //       }

                                  //       // if (
                                  //       //   formData.callStatus == "Call done" ||
                                  //       //   true
                                  //       // ) {
                                  //       //   saveEcd(formData);
                                  //       // }

                                  //       // return early
                                  //       // return;
                                  //     }
                                  //   }

                                  //   //this will check if the fields are empty
                                  //   if (Object.keys(errorss).length !== 0) {
                                  //     console.log("form errors", errorss);
                                  //     // we still return because there might be other errors
                                  //     return;
                                  //   }

                                  //   // DO THIS AFTER THE MODAL LOGIC
                                  //   // There will be errors even if the callStatus and connectivity status are defined
                                  //   // so we save it none the less
                                  //   // updateStatus(
                                  //   //   selectedData._id,
                                  //   //   formData.callStatus,
                                  //   // );

                                  //   function updateStatusFun() {
                                  //     updateStatus(
                                  //       selectedData._id,
                                  //       formData.callStatus,
                                  //     );
                                  //     if (
                                  //       formData.callStatus == "Call done" ||
                                  //       true
                                  //     ) {
                                  //       // alert("I am still here");
                                  //       // return;
                                  //       saveEcd(formData);
                                  //     }
                                  //   }

                                  //   updateStatusFun();
                                  // } catch (error) {
                                  //   console.log(
                                  //     "What the fuck is going on ",
                                  //     error,
                                  //   );
                                  // }
                                }}
                              >
                                {savingEcd ? "Saving..." : "Save"}
                              </Button>
                            </div>
                          </Box>
                        )}
                        {selectedData.status == "Call done" && ecd && (
                          <Box sx={{ p: 1 }}>
                            <Box sx={{ mb: 1 }}>
                              <Typography
                                variant="p"
                                sx={{ color: "#375674", fontSize: "1.3em" }}
                              >
                                {" "}
                                ECD Data
                              </Typography>
                            </Box>
                            <Box>
                              <Box
                                sx={{ padding: 1, border: ".5px solid grey" }}
                              >
                                <Typography
                                  variant="p"
                                  sx={{ color: "#577592", fontSize: ".8em" }}
                                >
                                  Week :{" "}
                                  <span
                                    style={{
                                      color: "#375674",
                                      fontSize: "1.2em",
                                    }}
                                  >
                                    {ecd.week}{" "}
                                  </span>
                                </Typography>
                              </Box>
                              <Box
                                sx={{ padding: 1, border: ".5px solid grey" }}
                              >
                                <Typography
                                  variant="p"
                                  sx={{ color: "#577592", fontSize: ".8em" }}
                                >
                                  Month:{" "}
                                  <span
                                    style={{
                                      color: "#375674",
                                      fontSize: "1.2em",
                                    }}
                                  >
                                    {ecd.pregnancyMonth}
                                  </span>{" "}
                                </Typography>
                              </Box>
                              <Box
                                sx={{ padding: 1, border: ".5px solid grey" }}
                              >
                                <Typography
                                  variant="p"
                                  sx={{ color: "#577592", fontSize: ".8em" }}
                                >
                                  Trimester:{" "}
                                  <span
                                    style={{
                                      color: "#375674",
                                      fontSize: "1.2em",
                                    }}
                                  >
                                    {ecd.trimester}
                                  </span>
                                </Typography>
                              </Box>

                              <Box
                                sx={{ padding: 1, border: ".5px solid grey" }}
                              >
                                <Typography
                                  variant="p"
                                  sx={{ color: "#577592", fontSize: ".8em" }}
                                >
                                  ICDS Scheme status :{" "}
                                  <span
                                    style={{
                                      color: "#375674",
                                      fontSize: "1.2em",
                                    }}
                                  >
                                    {ecd.ICDSSchemeStatus || ""}{" "}
                                  </span>
                                </Typography>
                              </Box>
                              <Box
                                sx={{ padding: 1, border: ".5px solid grey" }}
                              >
                                <Typography
                                  variant="p"
                                  sx={{ color: "#577592", fontSize: ".8em" }}
                                >
                                  Advice:
                                  <span
                                    style={{
                                      color: "#375674",
                                      fontSize: "1.2em",
                                    }}
                                  >
                                    {" "}
                                    {ecd.advice}
                                  </span>
                                </Typography>
                              </Box>
                              <Box
                                sx={{ padding: 1, border: ".5px solid grey" }}
                              >
                                <Typography
                                  variant="p"
                                  sx={{ color: "#577592", fontSize: ".8em" }}
                                >
                                  Alternate Number :{" "}
                                  <span
                                    style={{
                                      color: "#375674",
                                      fontSize: "1.2em",
                                    }}
                                  >
                                    {ecd.alternateNumber || ""}{" "}
                                  </span>
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        )}
                      </>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={{ width: "30%", height: "80vh", position: "relative" }}>
          <Box
            sx={{
              position: "absolute",
              // width: "60px",
              // height: "60px",
              top: 2,
              // right: 0,
              left: "50%",
              marginLeft: "auto",
              marginRight: "auto",
              transform: "translate(-50%, 0)",
            }}
          >
            {/* REFRESH IFRAME */}
            <IconButton
              variant="outlined"
              size="small"
              onClick={() => {
                setShowOzonetelIframe(false);
                // will rerender the component in 100 ms
                // might cause some sideeffects due to timeout not being cleared
                setTimeout(() => {
                  setShowOzonetelIframe(true);
                }, 100);
              }}
            >
              <RefreshIcon
                sx={{
                  width: "2rem",
                  height: "2rem",
                }}
              />
            </IconButton>
          </Box>
          {/* <Iframe iframe={iframe} /> */}
          {loginObj && showOzonetelIframe && (
            <Iframe
              customer={Customer}
              agentid={loginObj.agentId}
              phoneNumber={loginObj.phoneNumber}
              pin={loginObj.pin}
            />
          )}
        </Box>
      </Box>

      <Modal
        open={openNewCase}
        handleClose={() => {
          setOpenNewCase(false);
        }}
        head={`Search Mother`}
        buttons={[
          {
            name: "Cancel",
            onClick: () => {
              setOpenNewCase(false);
            },
          },
        ]}
      >
        <Paper
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: 400,
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Search by Mother ID"
            value={searchK}
            onChange={(e) => {
              setSearchK(e.target.value);
              setSearched(null);
            }}
            inputProps={{ "aria-label": "Search by Mother ID" }}
          />
          <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
            <SearchIcon
              onClick={() => {
                setSearched(null);
                search("yes");
              }}
            />
          </IconButton>
        </Paper>
        {searched && searched != "not found" && (
          <>
            <Typography sx={{ mt: 1, fontSize: ".7em" }}>
              ----------Found mother ID ---------------
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                p: 1,
                alignItems: "center",
                pt: 1,
                border: "1px solid grey",
              }}
            >
              <Typography>{`#${searched.motherID} ${searched.name}  `}</Typography>
              <Button
                onClick={() => {
                  createNewCase(searched._id, selectedData._id);
                  setOpenNewCase(false);
                }}
              >
                Create new Case
              </Button>
            </Box>
          </>
        )}
        {searched && searched == "not found" && (
          <>
            <Typography sx={{ mt: 1, fontSize: ".7em" }}>
              ----------No Mother Id Found ---------------
            </Typography>
          </>
        )}

        <Box sx={{ mb: 3 }}></Box>
      </Modal>

      <Modal
        open={open}
        handleClose={() => {
          setOpen(false);
        }}
        head={`Mother Details`}
        buttons={[
          {
            name: "Cancel",
            onClick: () => {
              setOpen(false);
            },
          },
          {
            name: "Save",
            onClick: () => {
              if (inboundAction == "new") {
                saveAndEdit(formData2);
              } else {
                saveMotherDetails(selectedData._id);
              }
            },
          },
        ]}
      >
        <Paper
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: 400,
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Search by Mother ID"
            value={searchK}
            onChange={(e) => {
              setSearchK(e.target.value);
              setSearched(null);
            }}
            inputProps={{ "aria-label": "Search by Mother ID" }}
          />
          <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
            <SearchIcon
              onClick={() => {
                setSearched(null);
                search();
              }}
            />
          </IconButton>
        </Paper>
        {searched && searched != "not found" && (
          <>
            <Typography sx={{ mt: 1, fontSize: ".7em" }}>
              ----------Found mother ID ---------------
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                p: 1,
                alignItems: "center",
                pt: 1,
                border: "1px solid grey",
              }}
            >
              <Typography>{`#${searched.motherID} ${searched.name}  `}</Typography>
              <Button
                onClick={() => {
                  const formD = {
                    motherID: searched?.motherID || "",
                    name: searched?.name || "",
                    contact: searched?.contact || "",
                    districtId: searched?.districtId || "",
                  };
                  setFormData2(formD);
                  saveAndEdit(formD);
                  // saveMotherDetails(searched._id)
                }}
              >
                Link Mother
              </Button>
            </Box>
          </>
        )}
        {searched && searched == "not found" && (
          <>
            <Typography sx={{ mt: 1, fontSize: ".7em" }}>
              ----------No Mother Id Found ---------------
            </Typography>
          </>
        )}

        <Box sx={{ mb: 3 }}></Box>

        {Array.isArray(fields) && (
          <FormA
            fields={fields}
            data={{ Districts }}
            onChange={(name, value, multiple) => {
              formData2[name] = value;
              setFormData2({ ...formData2 });
            }}
            state={formData2 || {}}
          />
        )}
      </Modal>

      <Modal
        open={openLogin}
        handleClose={() => {
          setOpenLogin(false);
        }}
        head={`Ozonetel Login Details`}
        buttons={[
          {
            name: "Close",
            onClick: () => {
              setOpenLogin(false);
            },
          },
          {
            name: "Save",
            onClick: () => {
              saveLogin();
            },
          },
        ]}
      >
        <Box sx={{ mt: 2 }}>
          <FormA
            fields={[
              {
                type: "text",
                label: "Campaign",
                required: true,
                name: "campaign",
              },
              {
                type: "text",
                label: "AgentId",
                required: true,
                name: "agentId",
              },
              {
                type: "text",
                label: "Phone Number",
                required: true,
                name: "phoneNumber",
              },

              {
                type: "text",
                label: "PIN",
                required: true,
                name: "pin",
              },
            ]}
            data={{}}
            onChange={(name, value, multiple) => {
              loginData[name] = value;
              setLoginData({ ...loginData });
            }}
            state={loginData || {}}
          />

          {saveMessage && (
            <Typography sx={{ color: "green" }}>{saveMessage}</Typography>
          )}
        </Box>
      </Modal>

      {/* Modal for clarifying whether to reattempt the call on some other day or same day */}
      <MuiModal open={openReattemptModal} onClose={handleCloseReattemptModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)", // Centering the modal
            bgcolor: "background.paper", // Background color
            borderRadius: 1,
            boxShadow: 3,
            p: 3,
            width: "400px", // Set a fixed width for the modal
          }}
        >
          <Typography variant="h6" component="h2">
            Reattempt Call
          </Typography>
          <Typography sx={{ mt: 2 }}>
            Do you want to reattempt the call on some other day or the same day?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Button variant="contained" onClick={handleReattemptSameDay}>
                Reattempt on Same Day
              </Button>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                ml: 2,
                flexDirection: "column",
                rowGap: 1,
              }}
            >
              <TextField
                type="date"
                value={selectedDate}
                inputProps={{
                  min: new Date(new Date().setHours(0, 0, 0, 0))
                    .toISOString()
                    .split("T")[0],
                  max: new Date(new Date().setDate(new Date().getDate() + 10))
                    .toISOString()
                    .split("T")[0], // Example: max 1 month ahead
                }}
                onChange={(e) => setSelectedDate(e.target.value)}
                sx={{ mr: 1 }}
              />
              <Tooltip
                title="This feature is not available in the current version"
                placement="top"
                arrow
              >
                <span>
                  <Button
                    variant="contained"
                    onClick={handleReattemptOnSelectedDate}
                    disabled={true}
                  >
                    Reattempt
                  </Button>
                </span>
              </Tooltip>
            </Box>
          </Box>
        </Box>
      </MuiModal>
    </>
  );
};
